{
  "ariaLabel": {
    "viewDetails": "Ver detalles",
    "downloadDataAssets": "Descargar recursos de datos"
  },
  "topMenu": {
    "dihTitle": "Data Intelligence Hub",
    "DIHOrgRegistration": "Data Intelligence Hub: registro de la organización",
    "dihSubTitle": "Extraer valor de los datos de forma segura",
    "logout": "Cerrar sesión",
    "myAccount": "Mi cuenta",
    "myOrganization": "Mi organización"
  },
  "userLogoutAlert": {
    "title": "¿Seguro que quiere cerrar sesión?",
    "back": "Volver atrás",
    "logout": "Cerrar sesión",
    "myOrganization": "Mi organización"
  },
  "sideMenu": {
    "dashboard": "Cuadro de mandos",
    "connectors": "Conectores",
    "myConnectors": "Mis conectores",
    "dataspaces": "Espacios de datos",
    "discover": "Descubrir",
    "manage": "Gestionar",
    "marketplace": "Mercado",
    "myDataspaces": "Mis suscripciones",
    "browseDataspaces": "Explorar espacios de datos",
    "organizations": "Organizaciones",
    "build": "Crear",
    "ownedDataspaces": "Mis espacios de datos",
    "collapse": "Ocultar barra lateral",
    "participate": "Participar",
    "getVerified": "Ser verificado",
    "workbench": "Mesa de trabajo",
    "dataIncoming": "Datos recibidos",
    "applications": "Aplicaciones",
    "verify": "Verificar",
    "digitalIDDashboard": "Obtener información",
    "mySignatures": "Mis firmas",
    "externalConnectionManager": "Administrador de conexiones externas"
  },
  "dropdown": {
    "selectAll": "Seleccionar todo",
    "noOption": "No hay opciones disponibles",
    "noSuchOption": "No existe tal opción..."
  },
  "common": {
    "start": "Iniciar",
    "finish": "Finalizar",
    "firstName": "Nombre",
    "lastName": "Apellidos",
    "email": "Dirección de correo electrónico",
    "phoneNumber": "Número de teléfono",
    "contactPerson": "Persona de contacto",
    "welcome": "Bienvenida",
    "street": "Calle",
    "city": "Ciudad",
    "region": "Región",
    "country": "País",
    "postCode": "Código postal",
    "number": "Número",
    "next": "Siguiente",
    "prev": "Volver atrás",
    "alreadyAccount": "¿Ya tiene una cuenta?",
    "login": "Iniciar sesión",
    "loginNow": "Iniciar sesión ahora",
    "register": "Registrarse",
    "home": "Inicio",
    "submit": "Enviar",
    "attention": "Atención",
    "desc": "Descripción",
    "website": "Página web",
    "contact": "Contacto",
    "details": "Detalles",
    "plan": "Plan",
    "listView": "Vista de lista",
    "gridView": "Vista de cuadrícula",
    "firstPage": "Ir a la primera página",
    "previousPage": "Ir a la página anterior",
    "nextPage": "Ir a la página siguiente",
    "lastPage": "Ir a la última página",
    "download": "Descargar",
    "delete": "Eliminar",
    "edit": "Editar",
    "information": "Información",
    "organization": "Organización",
    "cancel": "Cancelar",
    "save": "Guardar",
    "upload": "Cargar",
    "link": "Enlace",
    "view": "Ver",
    "search": "Buscar",
    "searchTerm": "Buscar",
    "selectOption": "Seleccionar una opción",
    "sortBy": "Ordenar por",
    "dataspace": "Espacio de datos",
    "select": "Seleccionar",
    "date": "Fecha",
    "title": "Título",
    "successful": "Éxito",
    "unsuccessful": "Sin éxito",
    "statuses": {
      "connected": "conectado",
      "disconnected": "desconectado",
      "deploying": "desplegando",
      "deployed": "desplegado",
      "failed": "fallido",
      "available": "disponible",
      "success": "éxito",
      "active": "activo",
      "pending": "pendiente",
      "declined": "rechazado",
      "invited": "invitado",
      "onboarding": "incorporación",
      "withdrawn": "retirado",
      "successful": "exitoso",
      "unsuccessful": "sin éxito",
      "valid": "válido",
      "expired": "expirado",
      "revoked": "revocado",
      "inprogress": "en progreso",
      "rejected": "rechazado",
      "inactive": "inactivo",
      "subscribed": "suscrito"
    },
    "andMore": "y {count} más",
    "confirm": "Confirmar",
    "yes": "Sí",
    "no": "No",
    "links": {
      "dihWiki": "https://docs.dih.telekom.com/en/home"
    },
    "formError": "Algo anda mal.",
    "question": {
      "interested": "¿Le interesa?"
    },
    "moreInfo": "Si necesita más información:",
    "goToWebsite": "Ir a nuestra página web",
    "provider": "Proveedor",
    "required": "Obligatorio",
    "errors": "Errores",
    "error": "Error",
    "from": "De",
    "to": "Para",
    "openLinkInNewTab": "Abrir enlace en una nueva pestaña",
    "formatError": "Formato no válido. Por favor, compruebe su entrada e inténtelo de nuevo",
    "ID": "ID"
  },
  "genericError": "Se ha producido un error. Por favor, vuelva a intentarlo.",
  "validation": {
    "fieldRequired": "El campo {field} es obligatorio.",
    "fieldNumeric": "El campo sólo puede contener números.",
    "fieldAlpha": "El campo sólo puede contener letras, _ y -.",
    "fieldAlphanumeric": "El campo sólo puede contener letras, números, _ y -.",
    "fieldNumericDash": "El campo sólo puede contener números y -.",
    "fieldHouseNumber": "El campo {field} puede contener solo números, letras y los caracteres - y /.",
    "fieldPhoneNumber": "El campo sólo puede contener números y -. Debe comenzar con + o 00.",
    "fieldAlphaDash": "El campo sólo puede contener letras y -.",
    "exceptHTMLTagBrackets": "El campo no puede contener los siguientes caracteres: ^<>",
    "alphaNumericExtended": "El campo {field} solo puede contener letras, números, -, /, # y .",
    "ipOrCidrRegex": "El valor debe ser una dirección IP válida",
    "isMaxLength": "supera la longitud máxima de 10 caracteres.",
    "emailFormat": "La dirección de correo electrónico tiene un formato incorrecto",
    "fileSizeError": "El tamaño del archivo es superior a {size} MB.",
    "csvFileSizeError": "Este archivo es demasiado grande. Puede cargar archivos de hasta {size} MB.",
    "csvFileExtensionError": "Solo se permiten archivos con la extensión csv.",
    "csvFileIsEmptyError": "Este archivo está vacío. Debe cargar al menos {size} KB archivo.",
    "csvFileFormatError": "El archivo no coincide con el formato esperado. Utilice la plantilla proporcionada e inténtelo de nuevo.",
    "uploadFails": "Error de carga",
    "fileExtensionError": "La extensión del archivo no es apta",
    "fileIsMalwareInfectedError": "Este archivo parece contener malware. Por razones de seguridad, este archivo no se puede cargar. Por favor, vuelva a revisar su archivo",
    "customValidation": "El campo {field} tiene un formato incorrecto.",
    "selectCountryFirst": "Por favor, seleccione primero el nombre del país",
    "validationPostCodeCaseDE": "El campo tiene un formato incorrecto. Debe contener 5 dígitos; ej., 53113",
    "validationAlphanumericCase": "El campo sólo puede contener caracteres alfanuméricos, guiones y guiones bajos. El valor debe comenzar con un carácter alfanumérico.",
    "validationNumericDashCase": "El campo solo puede contener números y -.",
    "url": "Por favor, introduzca una URL válida",
    "maxInvitationSize": "Puedes invitar hasta {size} participantes a la vez",
    "errorUploadingFile": "Error al subir el archivo. Por favor, inténtalo de nuevo.",
    "password": {
      "passwordStrength": "Seguridad de la contraseña",
      "weak": "No segura",
      "average": "Intermedia",
      "strong": "Segura",
      "passwordValidationMoreChar": "{count} o más caracteres",
      "passwordUpperAndLowerChar": "Mayúsculas y minúsculas",
      "passwordAtLeastNumber": "Al menos un número",
      "passwordAtLeastSpecialChar": "Al menos un carácter especial (excepto <>&\"`[])",
      "passwordDiffFromPrev": "Difiere de sus contraseñas anteriores"
    },
    "orgName": "El campo sólo puede contener letras, números, _ y - &.",
    "tagLimitMessage": "Solo puede agregar hasta {count} casos de uso."
  },
  "footer": {
    "tagLine": "Potenciemos un mayor rendimiento",
    "imprint": "Nota legal",
    "imprintShort": "Nota legal",
    "imprintLink": "https://dih.telekom.com/en/imprint",
    "contact": "Contacto",
    "contactLink": "https://dih.telekom.com/en/contact",
    "termsAndConditions": "Términos y condiciones",
    "privacy": "Política de privacidad",
    "privacyShort": "Política de priv.",
    "telekom": "T-Systems International GmbH. Todos los derechos reservados",
    "telekomShort": "T-Systems International GmbH",
    "note": "Telekom Data Intelligence Hub â€“ sólo para clientes empresariales",
    "brandedNote": "Con la tecnología de Telekom Data Intelligence Hub",
    "help": "Ayuda",
    "cookieSettings": "Ajustes de cookies",
    "cookieSettingsShort": "Cookies",
    "life": "La vida es para compartir"
  },
  "onboarding": {
    "welcome": "Le damos la bienvenida a Data Intelligence Hub",
    "welcomeDIH": "Le damos la bienvenida a Data Intelligence Hub",
    "thankYouEnterprise": "Gracias por elegir Connect & Integrate Enterprise",
    "informationForOrganization": "Información sobre su organización",
    "orgNameLabel": "Nombre de la organización",
    "orgUnitNameLabel": "Nombre de la unidad organizativa",
    "emailAddressLabel": "Dirección de correo electrónico",
    "countryNameLabel": "País",
    "bpnNumberLabel": "Número de socio comercial",
    "contactPersonInfo": "Persona de contacto",
    "fillInfoBelow": "Por favor, rellene la información que aparece a continuación.",
    "orgRegNameLabel": "Nombre registrado de la organización/unidad",
    "legalNameHint": "Por favor introduzca el nombre legal de su organización",
    "addressHeading": "Dirección de la sede principal de la organización",
    "PLZCode": "Código postal",
    "verifyEmail": "Verificar correo electrónico",
    "verifyEmailMessage": "Gracias por unirse a Data Intelligence Hub - su organización ya está registrada con nosotros. Por favor, verifique su correo electrónico",
    "taxId": "Número de IVA",
    "commerceRegisterNumber": "Número de registro comercial",
    "orgRepresentative": {
      "title": "Configure la cuenta del representante de su organización",
      "orgContactPerson": "Persona de contacto de la organización",
      "whatDefinesYou": "¿Qué le define mejor?",
      "agreeText": "Confirmo que he leído y que me atendré a {1} de Data Intelligence Hub",
      "confirmText": "Doy mi consentimiento para que mis datos personales sean almacenados y procesados de acuerdo con <a href='#'>la declaración de privacidad de datos</a>"
    },
    "success": "Organización registrada correctamente",
    "underReview": "Su organización está siendo verificada",
    "verified": "Ha verificado correctamente su organización",
    "month": "mes | {count} mes",
    "steps": {
      "counter": {
        "step": "Paso",
        "of": "de"
      },
      "stepWizard": {
        "orgInfo": "Información sobre la organización",
        "selectConnection": "Seleccione su conexión",
        "configureConnection": "Configure su conexión",
        "selectPackage": "Seleccione su plan",
        "checkout": "Pagar",
        "enterpriseTitle": "Nos pondremos en contacto con usted en breve",
        "enterpriseSubtitle": "Mientras tanto, por favor danos un poco más de detalles para que podamos ayudarte mejor."
      },
      "actionButton": {
        "back": "Volver atrás",
        "next": "Siguiente",
        "order": "Pedido con obligación de pago",
        "checkout": "Pagar",
        "selectMyPlan": "Seleccionar mi plan",
        "submitRequest": "Enviar solicitud",
        "editModeDisabled": "No se han realizado cambios en el pedido existente."
      },
      "orgStep": {
        "fields": {
          "orgInfoLabel": "Detalles de la organización",
          "dataSpaceAttributes": "Atributos adicionales",
          "orgName": "Nombre legal de la organización",
          "departmentName": "Nombre del departamento",
          "crnNumber": "Número de registro comercial",
          "taxId": "Número de IVA",
          "bpnNo": "Número de socio comercial",
          "addressInfo": "Dirección de facturación",
          "countryName": "País",
          "plzCode": "Código postal",
          "number": "Número",
          "city": "Ciudad",
          "street": "Calle",
          "contactPersonLabel": "Persona de contacto",
          "fullName": "Nombre completo",
          "firstName": "Nombre",
          "firstNamePlaceholder": "Introduzca su nombre",
          "lastName": "Apellidos",
          "lastNamePlaceholder": "Introduzca sus apellidos",
          "contactPerson": "Persona de contacto",
          "phoneNo": "Número de teléfono",
          "emailAdd": "Dirección de correo electrónico",
          "dataPrivacyCheck": "Doy mi consentimiento para que mis datos personales se almacenen y procesen de acuerdo con la {dataprivacystatement} y las {supplementaryDataPrivacyConditions}",
          "dataPrivacyCheckNew": "Autorizo que mis datos personales sean almacenados y procesados de acuerdo con la {dataprivacystatement}.",
          "termsAndConditionsCheck": "Confirmo que, como representante autorizado de la empresa, he leído, entendido y acepto los {termsandcondition}.",
          "dataprivacystatement": "Declaración de privacidad de datos",
          "supplementaryDataPrivacyConditions": "Condiciones de Privacidad de Datos complementarias",
          "termsandcondition": "Términos y condiciones",
          "agreeToEnterContract": "Acepto firmar un contrato con T-Systems International GmbH basado en la {serviceDescription} incluida más arriba",
          "serviceDescription": "descripción de los servicios",
          "markettingConsentCheck": "Acepto recibir correos electrónicos de marketing, cartas, llamadas telefónicas o SMS/MMS de T-Systems International GmbH y Telekom Deutschland GmbH sobre productos, servicios y eventos. Puedo revocar este consentimiento en cualquier momento enviando un correo electrónico a {email}."
        }
      },
      "connection": {
        "sectionHeading": "Seleccione su conexión",
        "sectionSubHeading": "Por favor seleccione el tipo de conexión para {dsName}",
        "textNote": "Sólo pueden seleccionarse las opciones compatibles con Catena-X",
        "recommendedConfiguration": "Configuración recomendada",
        "cloudProvider": "Proveedor de servicios en la nube",
        "cloudProviderTooltip": "Proveedor de nube recomendado con esta suscripción",
        "contactSales": "Póngase en contacto con el departamento de"
      },
      "packages": {
        "sectionHeading": "Seleccione su plan",
        "sectionSubHeading": "Variaciones del plan de datos",
        "basedOnYourSelection": "En función de su selección, le recomendamos lo siguiente",
        "dataPackage": "Paquete de datos",
        "outgoingTraffic": "Tráfico saliente",
        "storage": "Almacenamiento",
        "selectedDataPlan": "Seleccionar plan de datos",
        "dataPlanDetails": "Detalles del plan de datos",
        "dataPlanLabelForVolume": "Planes con volumen incluido",
        "dataPlanLabelFlexible": "Pago por uso",
        "packageAvailable": "Este paquete sólo está disponible con este plan",
        "chargesApply": "Se aplican cargos si el uso supera el límite de volumen",
        "additionalStorage": "Almacenamiento adicional",
        "additionalTraffic": "Tráfico saliente adicional",
        "oneTimeSetUpCharges": "Cargos de configuración únicos",
        "starterKit": "Kit de inicio",
        "starterKitTooltip": "Configure su entorno con facilidad, incluida la configuración de acceso técnico, la creación de cuentas, las pruebas de funcionalidad y la integración de la base de conocimientos. Para obtener información detallada, consulte la descripción del servicio proporcionada durante el proceso de pago",
        "onboardingKit": "Kit de incorporación",
        "onboardingKitTooltip": "Paquetes flexibles de consultoría por hora diseñados para brindar soporte personalizado para la implementación de soluciones de espacio de datos, proporcionados por nuestro equipo de profesionales especializados. Para obtener información detallada, consulte la descripción del servicio proporcionada durante el proceso de pago.",
        "pleaseSelectYourDesiredContractDuration": "Por favor, seleccione la duración de su contrato deseada",
        "subscriptionTitle": "Nombre para mostrar de la conexión",
        "subscriptionTitleLabel": "Introduzca el nombre para mostrar de la conexión",
        "automatedIntegrationCapabilities": "Capacidades de integración automatizada",
        "automatedIntegrationCapabilitiesTooltip": "Las “capacidades de integración automatizada” le proporcionan funciones adicionales para lograr una integración semiautomática con el espacio de datos. Estos incluyen mapeo de datos, conversión de datos de bajo código y más.",
        "boschDtrTitle": "¿Busca un registro de gemelos digitales de alto rendimiento de Bosch?",
        "optional": "Opcional",
        "boschDtrDescription": "Bosch ofrece el Digital Twin Registry (DTR), un directorio digital que permite la rápida identificación y recuperación de millones de gemelos digitales, facilitando su creación, asignación, almacenamiento y eliminación. Haga clic en la casilla de abajo y nuestro equipo de ventas estará encantado de ayudarle.",
        "boschDtrLearnMore": "Más información",
        "boschDtrContactSaleCheck": "Me gustaría que el equipo de ventas de T-Systems International GmbH se pusiera en contacto conmigo"
      },
      "zoneSelection": {
        "zoneSelectionTitle": "¿Dónde quieres que residan tus datos?",
        "zoneSelectionTooltip": "Elige el área donde quieres que residan tus datos."
      },
      "cloudProviders": {
        "cloudInfrastructure": "¿Qué proveedor de nube está en la zona seleccionada?",
        "toolipContent": "Elige el proveedor de nube que mejor se adapte a tus necesidades.",
        "cloudAvailable": "Este paquete sólo está disponible con este proveedor de servicios en la nube"
      },
      "checkout": {
        "sectionHeading": "Su paquete de conexión a {orgName}",
        "setupCost": "Gastos de instalación",
        "monthlyCost": "Costes mensuales",
        "payg": "Pago por uso",
        "pipSheet": "Hoja de información del producto",
        "totalCost": "Coste total",
        "totalPayable": "Total a pagar",
        "dataPrivacyCheck": "Acepto pagar los cargos asociados a los servicios solicitados más arriba",
        "termsAndConditionsCheck": "Acepto la duración del contrato y las condiciones de cancelación",
        "termsandcondition": "Términos y condiciones",
        "EOMAmountPolicy": "Acepto que el importe total a pagar se calcule a final de mes",
        "generalAgreement": "Acepto firmar un contrato con T-Systems International GmbH basado en la descripción de los servicios incluida más arriba",
        "DPAAgreement": "Doy mi consentimiento al {dataprocessingagreement} (DPA)",
        "dataprocessingagreement": "Acuerdo de procesamiento de datos",
        "dataPackage": "Paquete de datos",
        "dataPlan": "Plan de datos",
        "outgoingTraffic": "Tráfico saliente incluido",
        "storagePrice": "Precio del almacenamiento",
        "perGigabyteForStorage": "/GB para almacenamiento",
        "perGigabyteForOutgoingTraffic": "/GB para tráfico saliente",
        "outgoingTrafficPrice": "Precio del tráfico saliente",
        "contractDuration": "Duración del contrato",
        "contractDurationIconTooltip": "Seleccione la duración de su contrato en función de sus requisitos",
        "contractDurationTooltip": "Duración recomendada del contrato con esta suscripción",
        "defaultContractDuration": "6 meses",
        "price": "Precio",
        "perGigabyte": "por GB",
        "monthlyCancelable": "cancelable mensualmente",
        "storage": "Almacenamiento incluido",
        "linksText": {
          "information": "Hoja de información",
          "service": "Descripción del servicio"
        },
        "plusCharges": "{plus} cargos por su consumo",
        "plus": "más",
        "basedOnConsumption": "basado en el consumo",
        "selectedConfiguration": "Configuración seleccionada",
        "oneTimeCosts": "Costos únicos",
        "connectionType": "Tipo de conexión",
        "dataIntegrationLevel": "Nivel de integración de datos",
        "addOns": "Complementos",
        "connectors": "Conectores",
        "totalUseCases": "Caso de uso total",
        "totalAmount": "Importe total",
        "supplementaryDataPrivacyConditionsCheck": "Doy mi consentimiento para que mis datos personales se almacenen y procesen de acuerdo con las {supplementaryDataPrivacyConditions}",
        "supplementaryDataPrivacyConditions": "Condiciones Complementarias de Privacidad de Datos",
        "withIncludedVolume": "con volumen incluido",
        "cloudProvider": "Proveedor de servicios en la nube",
        "selectedZone": "Región",
        "additionalCharges": "*Se aplican cargos si superas tu volumen mensual",
        "semiAutomatedApiCapability": "Semiautomatizado con capacidad de API",
        "manualApiCapability": "Manual con capacidad de API"
      },
      "useCases": {
        "title": "Seleccione su(s) caso(s) de uso",
        "tagText": "Cada caso de uso adicional cuesta 100€/mes.",
        "bodyText": "Seleccione los casos de uso para su participación en Catena-X. Debe seleccionar al menos uno; El primer caso de uso se incluye de forma predeterminada en la suscripción. Puede seleccionar tantos como desee, con una tarifa de 100 € aplicada por cada caso de uso adicional seleccionado además del primero."
      },
      "cancelModal": {
        "confirmQuestion": "¿Está seguro de que quiere cancelar la conexión seleccionada?",
        "confirmYes": "Sí, cancelar",
        "confirmNo": "No, continuar"
      },
      "enterprisePackage": {
        "inputTitle": "Mensaje",
        "inputPlaceholder": "Empezar a escribir",
        "emptyErrorMessage": "El mensaje no puede estar vacío o solo puede ser espacio",
        "validCharErrorMessage": "El mensaje contiene caracteres no válidos",
        "noURLsErrorMessage": "El mensaje no puede contener enlaces o URL",
        "limitRepeatsErrorMessage": "El mensaje contiene demasiados caracteres repetidos"
      }
    },
    "statuses": {
      "complete": {
        "title": "Ya se ha registrado",
        "description": "El enlace de registro no se puede volver a utilizar.",
        "buttonText": "Ir a inicio"
      },
      "error": {
        "title": "Se ha producido un error",
        "description": "Por favor, reinicie el proceso",
        "buttonText": "Reiniciar"
      },
      "expired": {
        "title": "Lamentablemente su enlace ha caducado",
        "description": "Por favor reinicie el proceso desde el portal de Catena-X.",
        "buttonText": "Volver a Catena-X"
      },
      "success": {
        "title": "Gracias por registrarse",
        "description": "Estamos revisando los detalles de su organización. Recibirá más información por correo electrónico",
        "buttonText": "Ir a nuestro sitio web"
      },
      "invalid": {
        "title": "No autorizado",
        "description": "No tiene autorización para acceder a esta página.",
        "buttonText": "Ir a nuestro sitio web"
      },
      "dih-success": {
        "title": "Gracias por su registro",
        "description": "Estamos revisando los detalles sobre su organización. Recibirá más información por correo electrónico",
        "buttonText": "Ir a nuestro sitio web"
      },
      "orgNotFound": {
        "title": "No hemos podido encontrar su organización",
        "descriptionLine1": "Lo sentimos. Parece que su organización no está incorporada o que aún no ha solicitado una suscripción a los servicios de T-Systems.",
        "descriptionLine2": "Por favor, solicite una suscripción a los servicios de habilitación certificados y personalizados de T-Systems para Catena-X a través del {marketplace}.",
        "marketplace": "marketplace",
        "descriptionLine3": "Si cree que se trata de un error, por favor {contactOurSalesTeam} y estaremos encantados de ayudarle.",
        "contactOurSalesTeam": "Contacte con nuestro equipo de ventas",
        "exploreTheKnowledgeBase": "Explore la base de conocimientos",
        "readOurBlog": "Lea nuestro blog"
      },
      "ds-success": {
        "title": "¡Gracias por su pedido",
        "description": "Hemos recibido con éxito los detalles de su organización.",
        "descriptionPara2": "Estamos revisando los detalles y nos pondremos en contacto con usted en breve por correo electrónico.",
        "buttonText": "Comenzar"
      }
    },
    "orgExistLogin": {
      "title": "Ya tienes una cuenta en Data Intelligence Hub?",
      "action": "Iniciar sesión",
      "error": {
        "permissionErrorTitle": "No tiene los permisos necesarios para acceder a esta página.",
        "permissionErrorText": "Póngase en contacto con el administrador de su organización para obtener más información",
        "orgNotFoundTitle": "Organización no encontrada",
        "orgNotFoundText": "No podemos identificar una organización a partir de su dirección de correo electrónico. Por favor, rellene el formulario de registro y proporcione los detalles de su pedido"
      }
    },
    "newOnboarding": {
      "address": {
        "country": "País*",
        "region": "Región*",
        "street": "Calle*",
        "number": "Número*",
        "postCode": "Código postal*",
        "city": "Ciudad*",
        "organisationAddress": "Dirección de la organización",
        "organisationAddressSubheading": "Por favor, introduzca la dirección de su organización",
        "billingAddress": "Dirección de facturación",
        "billingAddressSubheading": "Por favor, introduzca su dirección de facturación",
        "sameAsOrgAddress": "Mi dirección de facturación es la misma que la dirección de la organización."
      },
      "organisationInformation": "Información de la organización",
      "organisationInformationSubheading": "Por favor, introduzca la información de su organización",
      "organisationName": "Nombre legal de la organización",
      "organisationNameInfo": "Por favor, introduzca el nombre legal de la organización",
      "transliteratedName": "Nombre transliterado (Caracteres latinos)",
      "transliteratedNameInfo": "Opcional: Ingrese el nombre utilizando caracteres latinos para ayudar a nuestros revisores. No tiene que ser un nombre oficial.",
      "transliteratedNamePrompt": "Su nombre legal está en un sistema de escritura no latino. Por favor, considere proporcionar una transliteración en caracteres latinos para ayudar a nuestros revisores.",
      "transliteratedNameValidationMsg": "Proporcione una transliteración en caracteres latinos para ayudar a nuestros revisores.",
      "contactDetailsHeading": "Información de contacto",
      "contactDetailsSubheading": "Ingrese su información de contacto",
      "firstName": "Nombre*",
      "lastName": "Apellido*",
      "emailAddress": "Dirección de correo electrónico*",
      "phoneNumber": "Número de teléfono*",
      "companyIdentifierHeading": "Identificador de la organización",
      "companyIdentifierSubheading": "Introduzca al menos uno de los siguientes ID únicos para continuar*",
      "identifierType": "Tipo de identificador*",
      "identifierValue": "Valor del identificador*",
      "identifierTypeError": "Seleccione un tipo de identificador",
      "identifierValueError": "El valor del identificador es obligatorio",
      "identifierValueFormatError": "Formato no válido. Ejemplo: {field}"
    }
  },
  "dashboard": {
    "pageTitle": "Inicio",
    "pageSubtitle": "Este es su centro de control para todo dentro de Data Intelligence Hub"
  },
  "services": {
    "finishConfig": "Terminar configuración",
    "open": "Abrir",
    "viewDetails": "Ver detalles",
    "configure": {
      "uploadCertification": "Por favor cargue el certificado que recibió del operador del espacio de datos.",
      "dragAndDropCertificate": "Arrastre y suelte aquí su archivo del certificado.",
      "didntReceive": "¿No ha recibido uno o no sabe cómo conseguir uno? Siga los pasos que se indican aquí",
      "uploadSuccessMessage": "Certificado cargado correctamente"
    },
    "table": {
      "attribute": "Atributo",
      "value": "Valor",
      "apiKey": "Clave API",
      "apiKeyValue": "Valor de la clave de API",
      "controlPlaneUrl": "URL del plano de control",
      "idsURL": "Punto de conexión de la API de DSP",
      "connectorUrl": "URL del conector",
      "dataManagementUrl": "Punto de conexión de la API de administración de datos",
      "dataDashboard": "Panel de datos",
      "participantDid": "ID DID del participante"
    }
  },
  "dataspaces": {
    "dataspaces": "Espacios de datos",
    "viewAllDataspaces": "Ver todos los espacios de datos",
    "managedConnectorsHeading": "Managed connector(s)",
    "externalConnectorsHeading": "External connector(s)",
    "connectorTestDescription": "Aplicación para probar si tu conexión está funcionando como se espera y tu conexión al espacio de datos está activa.",
    "configure": {
      "pageTitle": "Configurar la conexión de los dataspaces",
      "basicInfo": "Información básica",
      "certificate": "Certificado",
      "instructionCertrificate": "Por favor cargue el certificado que recibió del operador del espacio de datos."
    },
    "connectorHealthCheck": {
      "title": "Comprobación de salud del conector",
      "copiedToClipboard": "Copiado al portapapeles",
      "description": "Con la ayuda de esta aplicación, se realiza una autoevaluación para comprobar si el conector que has seleccionado está configurado y funcionando como se espera. Esto no cambiará ninguna configuración o almacenamiento del conector seleccionado.",
      "connectorid": "ID del conector",
      "model": {
        "title": "Comprobación de salud del conector en progreso...",
        "body": "No puedes salir mientras la comprobación de salud esté en progreso. Si deseas salir, la comprobación de salud se terminará y tendrás que reiniciarla.",
        "toLeave": "No, quiero salir",
        "toFinish": "Terminar la comprobación de salud"
      },
      "banner": {
        "initiate": "La comprobación de salud puede tardar unos minutos en ejecutarse. Se te notificará tan pronto como el resultado esté disponible.",
        "success": "¡Tu autoevaluación de Connect fue exitosa! Para ver los resultados de pruebas anteriores, haz clic en Resultados arriba.",
        "failed": "¡Lo sentimos! Tu autoevaluación de Connect no fue exitosa. Por favor, contacta con {email} y estaremos encantados de ayudarte.",
        "email": "dih.support{'@'}telekom.com"
      },
      "buttonState": {
        "initiate": "Iniciar",
        "success": "Abrir Connect",
        "failed": "Contactar con soporte",
        "back": "Atrás"
      }
    },
    "browse": {
      "browseDataspace": "Explorar espacios de datos",
      "availableDS": "Espacios de datos disponibles",
      "howToConnect": "Cómo conectarse",
      "getConnected": "Conectarse",
      "requestConnection": "Solicitar conexión",
      "viewRequest": "Ver solicitud",
      "viewDetails": "Ver detalles",
      "highlightNote": "Si desea gestionar su suscripción a {selectedDataspaceName}, póngase en contacto con nuestro equipo de asistencia:",
      "uncoverByInvitation": "Mostrar por invitación",
      "dataspaceDetails": "Detalles del espacio de datos",
      "participantOverview": "Visión general de los participantes",
      "services": "Servicios",
      "networking": "Networking",
      "networkingDesc": "Este espacio de datos puede restringir el acceso de red a sus servicios y conectores por el rango de direcciones IP permitidas. En caso de que tu aplicación tenga problemas, por favor contacta con el administrador de tu espacio de datos para que ponga en lista blanca tu dirección/rango IP actual.",
      "networkingIPTitle": "Mi dirección IP (Navegador)",
      "networkingInfoText": "En caso de que tu aplicación se ejecute en un dispositivo separado, puedes iniciar sesión en ese dispositivo y emitir un comando como",
      "networkingCurlCommand": "“curl --location 'ifconfig.me/ip”",
      "networkingHighlightNote": "Para cualquier consulta, por favor contacta con nuestro soporte:",
      "joinRequestSuccessTitle": "Tu solicitud para unirte a {dataspaceName} ha sido enviada",
      "joinRequestSuccessBody": "Recibirás más información una vez que tu solicitud sea procesada",
      "dataspaceMembershipId": "ID de pertenencia al espacio de datos",
      "uncover": {
        "title": "Mostrar un espacio de datos por invitación",
        "subtitle": "¿Qué espacio de datos está buscando?",
        "fieldLabels": "Introduzca los detalles proporcionados por el operador del espacio de datos",
        "sendRequest": "Enviar solicitud",
        "back": "Volver atrás",
        "dataspaceId": "ID del espacio de datos",
        "password": "Contraseña"
      },
      "requestDetailsModal": {
        "withdraw": "Retirar",
        "cancel": "Cancelar",
        "update": "Actualizar",
        "withdrawConfirmationHeading": "Retirar solicitud de unión al espacio de datos",
        "withdrawConfirmationBody": "Vuelva a confirmar que tiene la intención de retirar su solicitud para unirse al espacio de datos {dataspaceName}.",
        "notification": {
          "withdrawSuccessfulTitle": "Se ha retirado la solicitud de unión al espacio de datos",
          "withdrawSuccessfulBody": "Su solicitud para unirse a {dataspaceName} ha sido retirada.",
          "updateSuccessfulTitle": "Solicitud de unión al espacio de datos actualizada",
          "updateSuccessfulBody": "Tu solicitud para unirte a {dataspaceName} ha sido actualizada."
        }
      }
    },
    "user": {
      "myMemberships": "Mis suscripciones",
      "enterDS": "Entrar en el espacio de datos",
      "registeredDS": "Tus espacios de datos",
      "noMembership": {
        "title": "Todavía no tiene ninguna suscripción",
        "description": "Explorar espacios de datos para unirse a uno",
        "actionButtonText": "Conectarse"
      }
    },
    "statuses": {
      "attentionRequired": "Atención necesaria",
      "comingSoon": "Próximamente",
      "connected": "Conectado",
      "disconnected": "Desconectado",
      "deploying": "Implementando",
      "deployed": "Implementado",
      "failed": "Error",
      "available": "Disponible",
      "success": "Hecho"
    }
  },
  "verify": {
    "orgProfile": "Perfil de la organización",
    "legalName": "Nombre legal",
    "address": "Dirección",
    "contact": "Contacto",
    "vatID": "Número de IVA",
    "requestChange": "Solicitar un cambio",
    "downloadVCMessage": "VC descargado correctamente",
    "placeholderEnterSelectInput": "Introducir o seleccionar valor de la lista",
    "vcOverview": {
      "masterHeading": "Tipos de credenciales",
      "credentialTypeCards": {
        "description": {
          "legalPerson": "Esta es una representación digital de la información de la entidad legal, como los detalles de registro, la identificación comercial o el estado legal de la organización",
          "serviceOffering": "Esta es una colección de activos y recursos que un Proveedor combina en un paquete para ofrecer a los Consumidores",
          "physicalResource": "Este es un recurso con un peso medible y una posición espacial, que representa una entidad tangible que sirve como anfitrión, manipulador o participante en interacciones con otras entidades físicas",
          "softwareResource": "Este es un tipo de activo que comprende funcionalidades no físicas, como el código fuente",
          "dataResource": "Este es un tipo de activo que consta de datos (incluidos también datos derivados) en cualquier forma e incluye la información necesaria para compartir datos"
        },
        "cta": {
          "enter": "Enter"
        }
      },
      "credentialOverview": "Descripción general de credenciales",
      "credentialErrorMessage": "Error al obtener credenciales de {type}",
      "searchByNamePlaceholder": "Buscar por nombre",
      "credentialErrorDetailsMessage": "Actualmente nos enfrentamos a dificultades técnicas para obtener credenciales, inténtelo de nuevo después de un tiempo"
    },
    "verifiableCredentials": {
      "getVerified": "Obtener verificación",
      "credentials": "Credenciales",
      "requestCredential": "Solicitar credencial",
      "whichTypeToSelect": "¿Qué tipo debo seleccionar?",
      "noCredentialsMessage": "Todavía no tiene credenciales {type}",
      "credentialInfoMessage": "Añadir credenciales aumentará su nivel de confianza entre los participantes de un ecosistema.",
      "credentialModalMessage": "Sus credenciales son las cualificaciones o información que establecen la identidad, competencia o legitimidad de una empresa.",
      "learnMore": "Más información",
      "status": {
        "all": "Todos",
        "valid": "Válido",
        "expired": "Expirado",
        "revoked": "Revocado"
      },
      "types": {
        "legalPerson": "Identificación de la empresa",
        "serviceOffering": "Cumplimiento y certificación",
        "physicalResource": "Recursos físicos",
        "dataResource": "Recursos de datos",
        "softwareResource": "Recursos de software",
        "membership": "Afiliaciones"
      },
      "form": {
        "type": {
          "placeholder": "Seleccione su tipo de credencial",
          "label": "Tipo de credencial",
          "error": "Se requiere el tipo de credencial"
        },
        "types": {
          "legalPerson": "Persona jurídica",
          "serviceOffering": "Oferta de servicios",
          "physicalResource": "Recurso físico",
          "resource": "Recurso",
          "dataResource": "Recurso de datos",
          "softwareResource": "Recurso de software"
        },
        "companyInformationSectionTitle": "Información sobre la empresa",
        "companyInformationSectionSubtitle": "Por favor, utilice el nombre legal de la organización",
        "legalName": {
          "label": "Nombre legal de la organización",
          "helpText": "Por favor utilice el nombre legalmente vinculante de la organización"
        },
        "country": {
          "placeholder": "Seleccionar país",
          "label": "País",
          "error": "Se requiere el país"
        },
        "region": {
          "placeholder": "Seleccione región",
          "label": "Región",
          "error": "Se requiere región"
        },
        "street": {
          "label": "Calle y número"
        },
        "city": {
          "label": "Ciudad"
        },
        "postalCode": {
          "label": "Código postal"
        },
        "commercialIdentificationSectionTitle": "Identificación comercial",
        "commercialIdentificationSectionSubtitle": "Introduzca al menos uno de los siguientes ID únicos para continuar*",
        "CRN": {
          "label": "Número de registro comercial",
          "helpText": "Ejemplo: HRB 55933",
          "tooltipText": "El número de registro comercial es un identificador único asignado a las empresas para su registro comercial legal. Se utiliza para validar y verificar la autenticidad de los identificadores de registro y transacciones financieras de una empresa con fuentes de datos de confianza."
        },
        "vatId": {
          "label": "Número de IVA",
          "helpText": "Ejemplo: DE 118 645 675",
          "tooltipText": "El número de IVA (Impuesto sobre el Valor Añadido) es un identificador único que se asigna a las empresas para fines fiscales."
        },
        "eori": {
          "label": "EORI",
          "helpText": "Ejemplo: DE 103 280 493 572",
          "tooltipText": "El número EORI (número de Identificación y Registro de Operadores Económicos) es un identificador único asignado a los operadores económicos que participan en el comercio internacional dentro de la Unión Europea (UE)."
        },
        "lei": {
          "label": "LEI",
          "helpText": "Ejemplo: 5299009D9BIL4D4UHT93",
          "tooltipText": "El LEI (Identificador de Entidad Jurídica) es un código de identificación único asignado a las entidades jurídicas que realizan operaciones financieras en los mercados financieros globales."
        },
        "didSectionTitle": "Identificador descentralizado",
        "didSubSectionTitle": "Si no tienes un identificador descentralizado, deja este campo vacío, se generará automáticamente.",
        "did": {
          "label": "Sujeto de la credencial",
          "helpText": "did:example123456789abcd",
          "tooltipText": "Un DID es un identificador único que se puede resolver a un Documento DID. Los DIDs son los componentes fundamentales de la identidad digital descentralizada."
        },
        "certificate": {
          "error": "Se requiere certificado"
        },
        "request": "Solicitar",
        "requesting": "Solicitando...",
        "certificateSectionHeading": "Firma",
        "certificateSectionTitle": "¿Qué certificado le gustaría usar para firmar?",
        "addCertificate": "Agregar un nuevo certificado",
        "chooseCertificate": "Elija su certificado",
        "tsystemsCertificate": "Certificado de T-Systems",
        "yourCertificate": "Su certificado",
        "consentTooltip": "Al seleccionar esta opción, permite que T-Systems firme el documento anterior en su nombre. Para obtener más detalles, consulte la documentación",
        "consentPersonalData": "Por la presente, acepto y confirmo que todas las informaciones y datos personales (\"datos personales\") arriba indicados son correctos.",
        "consentProcessing": "Por la presente, doy mi consentimiento y autorizo a Gaia-X a tratar cualquiera de mis datos (incluidos datos personales confidenciales)."
      },
      "vcRequestSuccess": "La solicitud se ha enviado con éxito",
      "selectAllButton": "Seleccionar todo",
      "deselectAllButton": "Deseleccionar todo",
      "revokeButton": "Revocar",
      "searchboxPlaceholder": "Introducir al menos 3 caracteres",
      "credentialTile": {
        "issuedBy": "Emitida por",
        "issuedOn": "Emitida el",
        "expiresOn": "Caduca el",
        "expiredOn": "Caducada el",
        "viewDetailsButton": "Ver detalles"
      },
      "revokeModal": {
        "heading": "Confirmación de revocación",
        "question": "¿Está seguro de que quiere revocar la credencial?",
        "note": "NOTA:",
        "message": "Tras revocar una credencial, ésta deja de ser válida y ya no puede utilizarse. Para obtener una credencial válida, deberá solicitar una nueva.",
        "primaryButton": "Revocar",
        "secondaryButton": "Cancelar"
      },
      "deleteCredential": {
        "heading": "Eliminar confirmación",
        "question": "¿Está seguro de que desea eliminar la credencial?",
        "deleteSuccess": "Credencial eliminada correctamente"
      },
      "credentialsDetailsModal": {
        "heading": "Detalles de la credencial",
        "selfDescriptionCredential": "Credenciales de autodescripción",
        "type": "tipo",
        "id": "id",
        "issuer": "emisor",
        "issuanceDate": "fecha de emisión",
        "expirationDate": "fecha de caducidad",
        "credentialSubject": "objecto de la credencial",
        "bpn": "ctxsd:bpn",
        "participantName": "gx-participant:name",
        "participantNameLegalName": "gx-participant:legalName",
        "legalRegistrationNumber": "gx:participant:legalRegistrationNumber",
        "EUID": "gx:EUID",
        "leiCode": "gx:leiCode",
        "vatID": "gx:vatID",
        "registrationNumberType": "gx:registrationNumberType",
        "registrationNumberNumber": "gx:registrationNumberNumber",
        "headquarterAddress": "gx:participant:headquarterAddress",
        "addressCountryCode": "gx:addressCountryCode",
        "countrySubdivisionCode": "gx:countrySubdivisionCode",
        "locality": "gx:locality",
        "streetAddress": "gx:streetAddress",
        "legalAddress": "gx:participant:legalAddress",
        "termsAndConditions": "gx-participant:termsAndConditions",
        "serviceOfferingName": "gx:serviceOfferingName",
        "serviceOfferingDescription": "gx:serviceOfferingDescription",
        "providedBy": "gx:providedBy",
        "aggregationOf": "gx:aggregationOf",
        "aggregationOfId": "gx:id",
        "policy": "gx:policy",
        "serviceOfferingTermsAndConditions": "gx:termsAndConditions",
        "url": "gx:URL",
        "hash": "gx:hash",
        "dataAccountExport": "gx:dataAccountExport",
        "requestType": "gx:requestType",
        "accessType": "gx:accessType",
        "formatType": "gx:formatType",
        "proof": "Prueba",
        "created": "creado",
        "proofPurpose": "proofPurpose",
        "verificationMethod": "verificationMethod",
        "jws": "jws",
        "status": "Estado",
        "primaryButton": "Descargar",
        "secondaryButton": "Cancelar",
        "resourceName": "gx:name",
        "resourceDescription": "gx:description",
        "resourceCopyrightOwnedBy": "gx:copyrightOwnedBy",
        "resourceExposedThrough": "gx:exposedThrough",
        "resourceProducedBy": "gx:producedBy",
        "resourcePolicy": "gx:policy",
        "resourceLicense": "gx:license",
        "resourceContainsPII": "gx:containsPII",
        "resourceMaintainedBy": "gx:maintainedBy",
        "resourceOwnedBy": "gx:ownedBy",
        "resourceManufacturedBy": "gx:manufacturedBy",
        "resourceCountryCode": "Código de país",
        "resourceLocality": "Localidad",
        "resourcePostalCode": "Código postal",
        "resourceStreetAddress": "Dirección de la calle",
        "legalPersonRegistrationNumber": "gx:lagelRegistrationNumber"
      },
      "notificationText": "Lo sentimos, no hemos encontrado ningún resultado que coincida con sus criterios de búsqueda. Por favor, refine su búsqueda e inténtelo de nuevo.",
      "bulkUpload": {
        "title": "Valide a sus socios",
        "helpText": "Valide a sus socias comerciales de una sola vez rellenando la plantilla proporcionada",
        "uploadFileTitle": "Cargar archivo",
        "requestCredentials": "Solicitar credenciales",
        "uploadFormHelpHeading": "Para validar varias empresas, haga lo siguiente:",
        "uploadFormHelpText1": "Descargue el archivo de plantilla desde el siguiente enlace",
        "uploadFormHelpText2": "Rellene el archivo proporcionado con los detalles de sus socios comerciales",
        "uploadFormHelpText3": "Suelte el archivo en el área de carga que aparece a continuación",
        "downloadTemplateBtn": "Descargar plantilla",
        "partnerValidationHelpText": "Si deseas obtener más información sobre la validación de socios, por favor",
        "partnerValidationHelpLink": "haga click aquí",
        "uploadFile": {
          "uploadFileHeading": "Seleccione un archivo CSV para cargar"
        },
        "vcProcessingTitle": "Procesamiento de registros",
        "bulkVcContinueBtn": "Continuar",
        "issuingProgressMessage": "El proceso de emisión de credenciales está en curso...",
        "doNotCloseWarning": "Por favor, no cierre el formulario hasta que termine el procesamiento",
        "bulkVcDownloadReportBtn": "Descargar informe",
        "successMessage": "¡Completado con éxito!",
        "failedErrorMessage": "Errores en {result} entradas",
        "processAbortTitle": "Procesando",
        "processAbortDescription": "¿Está seguro de que deseas detener el procesamiento?",
        "stopProcessingBtn": "Detener procesamiento"
      },
      "validation": {
        "vatId": {
          "field": "Por favor, ingrese un número de IVA válido. ",
          "AT": "Consejo: Debe comenzar con 'ATU' seguido de 8 dígitos.",
          "BE": "Consejo: Debe comenzar con 'BE' seguido de 10 dígitos.",
          "BG": "Consejo: Debe comenzar con 'BG' seguido de 9 o 10 dígitos.",
          "CY": "Consejo: Debe comenzar con 'CY' seguido de 8 dígitos y 1 letra.",
          "CZ": "Consejo: Debe comenzar con 'CZ' seguido de 8 a 10 dígitos.",
          "DE": "Consejo: Debe comenzar con 'DE' seguido de 9 dígitos.",
          "DK": "Consejo: Debe comenzar con 'DK' seguido de 8 dígitos.",
          "EE": "Consejo: Debe comenzar con 'EE' seguido de 9 dígitos.",
          "EL": "Consejo: Debe comenzar con 'EL' seguido de 9 dígitos.",
          "ES": "Consejo: Debe comenzar con 'ES' seguido de una combinación de letras y dígitos.",
          "FI": "Consejo: Debe comenzar con 'FI' seguido de 8 dígitos.",
          "FR": "Consejo: Debe comenzar con 'FR' seguido de 2 letras y 9 dígitos.",
          "HR": "Consejo: Debe comenzar con 'HR' seguido de 11 dígitos.",
          "HU": "Consejo: Debe comenzar con 'HU' seguido de 8 dígitos.",
          "IE": "Consejo: Debe comenzar con 'IE' seguido de una combinación compleja de dígitos y letras.",
          "IT": "Consejo: Debe comenzar con 'IT' seguido de 11 dígitos.",
          "LT": "Consejo: Debe comenzar con 'LT' seguido de 9 a 12 dígitos.",
          "LU": "Consejo: Debe comenzar con 'LU' seguido de 8 dígitos.",
          "LV": "Consejo: Debe comenzar con 'LV' seguido de 11 dígitos.",
          "MT": "Consejo: Debe comenzar con 'MT' seguido de 8 dígitos.",
          "NL": "Consejo: Debe comenzar con 'NL' seguido de 9 dígitos y 'B' + 2 dígitos.",
          "PL": "Consejo: Debe comenzar con 'PL' seguido de 10 dígitos.",
          "PT": "Consejo: Debe comenzar con 'PT' seguido de 9 dígitos.",
          "RO": "Consejo: Debe comenzar con 'RO' seguido de 2 a 10 dígitos.",
          "SE": "Consejo: Debe comenzar con 'SE' seguido de 12 dígitos.",
          "SI": "Consejo: Debe comenzar con 'SI' seguido de 8 dígitos.",
          "SK": "Consejo: Debe comenzar con 'SK' seguido de 10 dígitos.",
          "XI": "Consejo: Debe comenzar con 'XI' seguido de 9 dígitos."
        },
        "eori": "Por favor, ingrese un EORI válido. Sugerencia: Debe comenzar con 2 letras mayúsculas seguidas de 9 a 15 dígitos.",
        "lei": "Por favor, ingrese un LEI válido. Sugerencia: Debe tener 20 caracteres, los primeros 18 alfanuméricos en mayúsculas y los últimos 2 dígitos.",
        "did": "Por favor, ingrese un DID válido. Debe comenzar con 'did:', seguido de método y segmentos separados por dos puntos, utilizando solo letras, dígitos, '%', '.', '_', y '-'.",
        "hash": "Por favor, ingrese un hash SHA-256 válido. Debe tener exactamente 64 caracteres hexadecimales (0-9, A-F).",
        "format_type": "Ingrese un tipo de formato válido. Debe ser una palabra seguida de un '/' y luego una cadena válida de caracteres (letras, dígitos, '-', '+', '.' o '_')"
      }
    },
    "serviceOfferingForm": {
      "generalInformationHeading": "Información general",
      "labelSOName": "Nombre de la oferta de servicios",
      "labelProvidedBy": "Proporcionado por",
      "labelSODescription": "Descripción de la oferta de servicios",
      "hintSOName": "Nombre legible de la Oferta de Servicios",
      "hintProvidedBy": "Enlace reutilizable en forma DID a la autodescripción del participante que presta el servicio",
      "hintSODescription": "Lista de políticas expresadas mediante DSL (por ejemplo, Rego o ODRL, control de acceso, limitación, uso, retención, ...)",
      "resourcesHeading": "Recursos",
      "labelSOResources": "Autodescripción de recursos",
      "hintSOResources": "Enlace reutilizable en forma de autodescripción de recurso DID, que está relacionado con el servicio y puede existir independientemente de él",
      "termsAndConditionsHeading": "Términos y condiciones",
      "labelUrlSO": "URL",
      "labelHashSO": "Hash",
      "labelSOPolicy": "Política",
      "policyTooltip": "Enlace resoluble a la Política aplicable a la Oferta de Servicios",
      "termsAndConditionsTooltip": "Enlace reutilizable a los términos y condiciones que se aplican a la oferta de servicios",
      "personalDEHeading": "Exportación de datos personales",
      "personalDETooltip": "Permite a los clientes del servicio exportar datos personales y no personales fuera del servicio.",
      "labelRequestTypeSO": "Tipo de solicitud",
      "labelAccessTypeSO": "Tipo de acceso",
      "placeholderRequestTypeSO": "Selecciona el tipo de solicitud",
      "placeholderAccessTypeSO": "Selecciona el tipo de acceso",
      "labelFormatTypeSO": "Tipo de formato",
      "hintRequestTypeSO": "El medio para solicitar la recuperación de datos: API, correo electrónico, formulario web, carta no registrada, carta registrada, centro de soporte",
      "hintAccessTypeSO": "Tipo de soporte de datos: digital, físico",
      "hintFormatTypeSO": "Tipo de tipos de medios (tipos MIME) definidos por",
      "consentTC1": "Por la presente acepto y confirmo que todos los datos ingresados anteriormente son precisos",
      "consentTC2": "Por la presente doy mi consentimiento y autorizo a T-Systems a procesar mis datos (incluidos los datos personales)",
      "consentTC3": "Por la presente acepto los",
      "gaiaXTermsText": "Términos y Condiciones de Gaia-X",
      "requestTypesList": {
        "api": "API",
        "email": "Correo electrónico",
        "webform": "Formulario web",
        "unregisteredLetter": "Carta no registrada",
        "registeredLetter": "Carta registrada",
        "supportCenter": "Centro de asistencia"
      },
      "requestTypesError": "Se requiere el tipo de solicitud",
      "accessTypesList": {
        "digital": "Digital",
        "physical": "Físico"
      },
      "accessTypesError": "Se requiere el tipo de acceso.",
      "helpSOName": "Introduzca un nombre legible para el ser humano de su servicio",
      "helpProvidedBy": "Identificador Descentralizado del Participante que presta el servicio",
      "helpSOResources": "Identificadores descentralizados de los Recursos que se exponen a través de este servicio",
      "helpUrlSO": "Introduzca el enlace a su documento de T&C (por ejemplo, https://service.com/terms)",
      "helpHashSO": "Ingrese un hash sha256 de su documento de T&C",
      "helpPolicySO": "Introduzca una política expresada mediante un DSL (por ejemplo, Rego u ODRL)",
      "helpRequestTypeSO": "Seleccione un tipo de solicitud de la lista desplegable",
      "helpAccessTypeSO": "Seleccione un tipo de acceso de la lista desplegable",
      "helpFormatTypeSO": "Introduzca el tipo MIME (por ejemplo, application/json)"
    },
    "resourceForm": {
      "generalInformationHeading": "Información general",
      "generalInformationSubHeading": "Ingrese la información general de su recurso",
      "labelResourceType": "Tipo de recurso",
      "placeholderResourceType": "Seleccionar tipo de recurso",
      "errorResourceType": "El tipo de recurso es obligatorio",
      "labelResourceName": "Nombre del recurso",
      "labelResourceDescription": "Descripción del recurso",
      "hintResourceType": "Tipo de recurso que se describe",
      "hintResourceName": "Nombre legible del recurso",
      "hintResourceDescription": "Descripción legible del recurso",
      "physicalResource": "Recurso físico",
      "softwareResource": "Recurso de software",
      "dataResource": "Recurso de datos",
      "additionalInformationHeading": "Información adicional",
      "additionalInformationSubHeading": "Por favor, introduzca la información adicional de su recurso",
      "labelMaintainedBy": "Mantenido por",
      "hintMaintainedBy": "Enlace reutilizable a Gaia-X Credencial del participante manteniendo el recurso en condiciones operativas y teniendo así acceso físico al mismo",
      "labelOwnedBy": "Propiedad de",
      "hintOwnedBy": "Enlace reutilizable a Gaia-X Credencial del participante propietario del recurso",
      "labelManufacturedBy": "Fabricado por",
      "hintManufacturedBy": "Enlace reutilizable a Gaia-X Credencial del participante que fabrica el recurso",
      "labelCountry": "País",
      "hintCountry": "País en el que se encuentra el recurso",
      "labelCity": "Ciudad",
      "hintCity": "Ciudad / pueblo en el que se encuentra el recurso",
      "labelPostCode": "Código postal",
      "hintPostCode": "Código postal en el que se encuentra el recurso",
      "labelStreet": "Calle",
      "hintStreet": "Calle y número de casa en el que se encuentra el recurso",
      "labelCopyrightOwnerBy": "Propietario de los derechos de autor por",
      "hintCopyrightOwnerBy": "Un propietario de derechos de autor es una persona u organización que tiene derecho a explotar el recurso. El propietario de los derechos de autor no se refiere necesariamente al autor del recurso, que es una persona física y puede diferir del propietario de los derechos de autor. Expresado como texto libre o como un enlace resoluble a la credencial Gaia-X del propietario de los derechos de autor.",
      "labelLicense": "Licencia",
      "hintLicense": "URL del documento de licencia o de una de las licencias de la",
      "labelPolicy": "Política",
      "hintPolicy": "Una lista de políticas expresadas mediante un DSL (por ejemplo, Rego u ODRL) (control de acceso, limitación, uso, retención, ...). Si se omite la restricción de directiva, se supone que el uso está permitido a todos los participantes",
      "labelProducedBy": "Producido por",
      "hintProducedBy": "Enlace reutilizable a la credencial Gaia-X del participante que habilita legalmente el uso de los datos.",
      "labelExposedThrough": "Expuesto a través de",
      "hintExposedThrough": "Vínculo reutilizable al componente de intercambio de datos que expuso el recurso de datos",
      "locationHeading": "Detalles de la ubicación",
      "locationSubHeading": "Por favor, introduzca los detalles de la ubicación de su recurso",
      "licenseTooltipText": "Lista de licencias de SPDX",
      "licenseTooltipLink": "https://spdx.org/licenses/",
      "consentPII": "Por la presente confirmo que el recurso de datos no contiene información de identificación personal (PII)."
    },
    "verifyLanding": {
      "heading": "Bienvenido a \"Get verified\"",
      "subHeading": "¡Aumente la confianza de tu ecosistema digital!",
      "description1": "¿Desea verificar y validar a sus socios comerciales, o quiere mostrar sus propias identificaciones y verificaciones? Entonces debería solicitar sus primeras Credenciales Verificables - nuestras",
      "description2": "Las Credenciales Verificables pueden contener la misma información que tienen tus identificaciones físicas (por ejemplo, tarjeta de identificación, licencia de conducir) e incluso más atributos. La incorporación de tecnologías, como las firmas digitales, hace que las credenciales verificables sean más seguras y fiables que sus contrapartes físicas.",
      "description3": "T-Systems opera como uno de los primeros nodos de Clearing House Digital de Gaia-X y emite tus pruebas digitales de acuerdo con las especificaciones del marco de confianza de Gaia-X. Además, añadimos nuestra firma digital conforme a eIDAS de nuestro socio Telekom Security.",
      "requestButton": "Solicitar Digital.ID",
      "digitalID": "producto Digital.ID.",
      "consultation": {
        "heading": "Solicite sus credenciales o valide a sus socios",
        "placeholder": "¿Alguna experiencia previa con credenciales verificables? ¿Está interesado en sus primeras credenciales?"
      },
      "sendAnotherRequest": "Enviar otra solicitud",
      "lastRequest": "Su última solicitud se envió el"
    },
    "getInsights": {
      "tab1": "Informes",
      "tab2": "Límites de uso de la API",
      "tab3": "Integración técnica",
      "monthsByOptions": {
        "option1": "3 Meses",
        "option2": "6 Meses",
        "option3": "1 Mes"
      },
      "table": {
        "heading2": "Período de referencia",
        "heading3": "Creado en",
        "heading4": "Acciones"
      },
      "successDownload": "Informe(s) descargado con éxito",
      "errorDownload": "Su descarga de archivos para {filename} ha abortado con error, por favor inténtelo de nuevo.",
      "apiUsageLimit": {
        "requestNameTitle": "Nombre de la solicitud",
        "dailyTitle": "Solicitudes diarias de API",
        "monthlyTitle": "Solicitudes mensuales de API",
        "limitexhaustedWarning": "Quedan menos del 10% de las solicitudes",
        "limitExtentionHeading": "Solicitar extensión de límite",
        "limitExtentionPlaceholder": "¿Está interesado en ampliar los límites de uso de su API?",
        "supportBtn": "Soporte",
        "limitExtentionText": "¿A punto de alcanzar el límite? Póngase en contacto con nosotros y lo solucionaremos."
      },
      "addIntegration": "Agregar integración",
      "integrationData": {
        "clientId": "ID de cliente",
        "createdAt": "Creado en",
        "actions": "Acciones"
      }
    },
    "addIntegration": {
      "generalInformationHeading": "Información general",
      "addAnIntegration": "Agregar una integración",
      "clientName": "Nombre del cliente",
      "clientId": "ID de cliente",
      "clientSecret": "Secreto de cliente",
      "tokenUrl": "URL del token",
      "pcCallbackUrl": "URL de devolución de llamada de credenciales de participante",
      "soCallbackUrl": "URL de devolución de llamada de credenciales de oferta de servicio",
      "digitalIdAuthenticateInfo1": "¿Cómo autenticará la Validación de Digital.ID contra su sistema?",
      "digitalIdAuthenticateInfo2": "¿Cómo autenticará el Cumplimiento de Digital.ID contra su sistema?",
      "seeResults": "¿Dónde debemos enviar los resultados?",
      "requestSuccess": "añadido con éxito",
      "callbackSuccess": "Callback añadido con éxito",
      "step1Name": "Detalles de autenticación de validación",
      "step2Name": "Detalles de autenticación de cumplimiento",
      "step3Name": "Información de devolución de llamada",
      "deleteSuccess": "Eliminado con éxito",
      "downloadSuccess": "Descargado con éxito",
      "editCallbackHeading": "Agregar devolución de llamada",
      "deleteModal": {
        "heading": "Eliminar confirmación",
        "deleteContent": "¿Estás seguro de que quieres eliminar el cliente?",
        "deleteNote": "Después de eliminar un cliente, desaparecerá de la lista y ya no se podrá usar. Para restaurarlo, tendrás que recrearlo desde cero."
      }
    },
    "mySignatures": {
      "certificatesOrdering": {
        "heading": "Bienvenidos a \"Mis firmas\"",
        "subHeading": "¿Desea solicitar un certificado digital que le permita firmar sus solicitudes?",
        "description1": "Con nuestro producto Digital.ID, puede solicitar fácilmente su primer certificado y comenzar a disfrutar de los beneficios de las colaboraciones digitales seguras.",
        "description2": "Las credenciales verificables pueden contener la misma información que sus identificadores físicos, como documentos de identidad y licencias de conducir, e incluso más. Durante el proceso de emisión, confirmará la exactitud de su información firmándola con su propio certificado de confianza.",
        "description3": "Puede solicitar y mantener de forma segura sus certificados digitales para todas sus necesidades de firma. Nos asociamos exclusivamente con proveedores de certificados digitales certificados, lo que garantiza que sus certificados digitales sean seguros y confiables.",
        "requestButton": "Solicitar Certificado",
        "consultation": {
          "heading": "Solicitar certificado",
          "placeholder": "Por favor, introduzca los datos necesarios sobre su solicitud"
        }
      },
      "certificateOverview": {
        "heading": "Mis firmas",
        "requestCertificateCTA": "Solicitar certificado",
        "placeholderCertificateType": "Tipo de certificado",
        "placeholderCertificateStatus": "Estado del certificado",
        "EVSSL": "EV SSL",
        "EIDAS": "EIDAS",
        "headingEVSSL": "Certificados EV SSL",
        "headingEIDAS": "Certificados EIDAS",
        "certificateDetailsHeading": "Detalles del certificado",
        "certificateName": "Nombre",
        "certificateId": "ID",
        "certificateType": "Tipo",
        "provider": "Proveedor",
        "organizationId": "ID de la organización",
        "UUID": "UUID",
        "certificate": "Certificado",
        "createdAt": "Creado el",
        "updatedAt": "actualizado el",
        "certificateExpiry": "Caduca el",
        "certificateVerificationMethod": "Método de verificación",
        "certificateDidJson": "DID JSON",
        "status": "Estado",
        "certificateDownloadSuccess": "Certificado descargado correctamente",
        "deleteCertificate": {
          "heading": "Eliminar confirmación",
          "question": "¿Está seguro de que desea eliminar el certificado?",
          "deleteSuccess": "Certificado eliminado con éxito"
        }
      }
    }
  },
  "build": {
    "ownedDataspaces": "Mis espacios de datos",
    "checkConsent": "Doy mi consentimiento para que se proporcionen mis datos de contacto a un equipo de ventas de T-Systems y para que se me contacten.",
    "welcomeOwnedDataspace": "Le damos la bienvenida a \"Espacios de datos propios\"",
    "resendInvitation": "Reenviar",
    "resendInvitationInfo": "Puedes enviar la notificación tan pronto como hayan pasado 24 horas desde el último correo de invitación.",
    "requestSuccessTitle": "¡Solicitud exitosa!",
    "requestSuccessBody": "Su solicitud ha sido enviada... Recibirás una respuesta en unos días hábiles",
    "requestAuthorisation": "Por favor, contacte a dih.support{'@'}telekom.com si desea aumentar la autorización necesaria.",
    "inviteParticipant": {
      "buttonLabel": "Invitar participante",
      "successNotificationTitle": "¡Invitación exitosa!",
      "successNotificationContent": "Tu invitación se ha enviado con éxito",
      "alreadySentNotificationTitle": "Ya se ha enviado una invitación a esta dirección de correo electrónico.",
      "alreadySentNotificationContent": "Por favor, espera 24 horas antes de enviar la invitación nuevamente.",
      "resendInviteNotificationTitle": "¡La reinscripción ha sido exitosa!",
      "resendInviteNotificationContent": "Tu reinvitación ha sido enviada exitosamente.",
      "modal": {
        "title": "Invitar participante",
        "informationTitle": "Información",
        "informationText": "La organización invitada puede intercambiar datos con otros participantes y publicar nuevos activos de datos en el dataspace. Además, la organización puede consumir aplicaciones y servicios que forman parte de tu dataspace.",
        "formTitle": "Por favor, ingresa los detalles del nuevo participante",
        "organizationName": "Nombre de la organización",
        "proceed": "Continuar",
        "cancel": "Cancelar"
      },
      "withdrawInvitation": {
        "modal": {
          "title": "Retirar invitación",
          "informationText": "¿Está seguro de que desea retirar la invitación?",
          "successNotificationTitle": "Retiro exitoso",
          "successNotificationBody": "Invitación retirada con éxito",
          "withdraw": "Retirar"
        }
      },
      "resendInvitation": {
        "modal": {
          "title": "Reenviar invitación",
          "informationText": "¿Está seguro de que desea volver a enviar esta invitación?"
        }
      }
    },
    "editParticipant": {
      "modal": {
        "title": "Editar participante",
        "cancel": "Cancelar",
        "save": "Guardar",
        "roleSection": {
          "name": "Rol",
          "helpText": "¿Qué rol debo seleccionar?",
          "helpUrl": "https://docs.dih.telekom.com/en/space/living-lab/manage-your-livinglab",
          "ownerLabel": "Propietario del espacio de datos",
          "ownerTooltip": "Propietario del espacio de datos que puede gestionar participantes y aplicaciones",
          "operatorLabel": "Operador del espacio de datos",
          "operatorTooltip": "Participante que puede gestionar herramientas del operador y registrar aplicaciones",
          "operatorCheckboxTooltip": "Usted es el propietario del espacio de datos. Por lo tanto, no puede deseleccionar Operador.",
          "appProviderLabel": "Proveedor de aplicaciones",
          "appProviderTooltip": "Participante del espacio de datos que puede registrar aplicaciones en el espacio de datos",
          "participantLabel": "Participante del espacio de datos",
          "participantTooltip": "Participante que puede actuar como proveedor de datos y consumidor de datos",
          "participantCheckboxTooltip": "El participante del dataspace no puede ser desactivado. Este es el estado predeterminado de un usuario en un dataspace."
        },
        "visibilitySection": {
          "name": "Visibilidad",
          "helpText": "¿Qué visibilidad debo seleccionar?",
          "helpUrl": "https://docs.dih.telekom.com/en/space/living-lab/manage-your-livinglab",
          "anonymousLabel": "Anónimo",
          "anonymousLabelTitle": "Participante anónimo",
          "anonymousTooltip": "Participante oculto para otros participantes y no puede ver a otros participantes"
        }
      },
      "updateSuccessfulTitle": "¡Actualización exitosa!",
      "updateSuccessfulBody": "El nuevo rol y visibilidad se han adoptado"
    },
    "applicationManagement": {
      "buttonLabel": "Registrar aplicación",
      "registerForm": {
        "pageTitle": "Registro de aplicación",
        "step1Name": "Detalles de la aplicación",
        "step2Name": "Acceso a la aplicación",
        "displayName": "Nombre visible",
        "providedBy": "Provisto por",
        "providedByPlaceholder": "Nombre de la organización",
        "description": "Descripción",
        "descriptionPlaceholder": "Texto de descripción",
        "link": "Enlace",
        "linkPlaceholder": "https://www.example.org/enlace-de-aplicación/",
        "errorUploadingFile": "Error al subir el archivo. Por favor, inténtalo de nuevo.",
        "appImage": "Imagen de la aplicación (JPG o PNG, máximo 2 MB)*",
        "appImagePlaceholder": "Arrastra y suelta archivos aquí, o haz clic para seleccionarlos",
        "appImagePlaceholder2": "o busca archivos en tu ordenador",
        "category": "Categoría",
        "categoryPlaceholder": "Ingrese categoría",
        "usecases": "Casos de uso",
        "usecasesPlaceholder": "Ingrese casos de uso",
        "agreementCheckboxLabel": "Por la presente, acepto que soy totalmente responsable y responsable de la aplicación que estoy registrando y que no es ningún tipo de malware. Además, me he asegurado de que no haya ninguna violación de licencia. Entiendo que soy totalmente responsable de la gestión del acceso de la aplicación y que T-Systems International GmbH no tiene responsabilidad en este sentido. T-System International GmbH no es responsable ni está obligado a responder por la aplicación y sus posibles consecuencias de ninguna manera."
      },
      "deleteApplication": {
        "modal": {
          "title": "Eliminar aplicación",
          "informationText1": "Por favor, vuelve a confirmar que estás seguro de que deseas eliminar este enlace de aplicación de tu dataspace. Esta aplicación no estará disponible para ningún participante dentro de tu dataspace.",
          "informationText2": "¡Ten en cuenta que la aplicación real permanecerá sin cambios!",
          "successNotificationTitle": "Eliminación exitosa",
          "successNotificationBody": "Aplicación eliminada con éxito",
          "cancel": "Cancelar",
          "delete": "Eliminar"
        }
      },
      "editForm": {
        "pageTitle": "Editar aplicación",
        "step1Name": "Detalles de la aplicación",
        "step2Name": "Acceso a la aplicación",
        "displayName": "Nombre visible",
        "providedBy": "Provisto por",
        "providedByPlaceholder": "Nombre de la organización",
        "description": "Descripción",
        "descriptionPlaceholder": "Texto de descripción",
        "link": "Enlace",
        "successNotificationTitle": "Edición exitosa",
        "successNotificationBody": "Aplicación editada con éxito",
        "linkPlaceholder": "https://www.example.org/enlace-de-aplicación/",
        "currentImage": "Imagen actual",
        "agreementCheckboxLabel": "Por la presente, acepto que soy totalmente responsable y responsable de la aplicación que estoy registrando y que no es ningún tipo de malware. Además, me he asegurado de que no haya ninguna violación de licencia. Entiendo que soy totalmente responsable de la gestión del acceso de la aplicación y que T-Systems International GmbH no tiene responsabilidad en este sentido. T-System International GmbH no es responsable ni está obligado a responder por la aplicación y sus posibles consecuencias de ninguna manera.",
        "cancel": "Cancelar",
        "save": "Guardar cambios"
      }
    },
    "networkManagement": {
      "buttonLabel": "Agregar nueva dirección IP",
      "pageTitle": "Gestión de red",
      "ipAddressLabel": "Dirección IP",
      "lastUpdatedOn": "Última actualización el",
      "ipHint": "La solicitud de actualización de la dirección IP ha sido recibida y será procesada en breve.",
      "ipRemove": "¿Está seguro de que desea eliminar esta dirección IP?",
      "ipRequired": "Se requiere una dirección IP",
      "ipInvalid": "Ingrese una dirección IP válida",
      "ipEnter": "Ingrese la dirección IP que desea incluir en la lista blanca para acceder al espacio de datos."
    },
    "invite": {
      "inviteLabel": "Invitar participante"
    },
    "allocateConnectors": {
      "pageTitle": "Asignación de conectores",
      "allocateConnectorLabel": "Asignar conectores",
      "topUpConnectorsButtonLabel": "Recargar conectores",
      "topUpConnectorTitle": "Tu solicitud se ha enviado correctamente.",
      "topUpConnectorBody": "Nuestro equipo de soporte se pondrá en contacto contigo lo antes posible para discutir más detalles.",
      "generalTooltipMessage": "Por favor, contacte con el soporte de DIH (dih.support{'@'}telekom.com) para asignar nuevos conectores a participantes existentes o para invitar a un nuevo participante al espacio de datos.",
      "tooltipMessage": "Ya ha agotado el número máximo de conectores disponibles según su contrato. Por favor, contacte con dih.support{'@'}telekom.com si desea aumentar la cuota o modificar el contrato.",
      "allocationForm": {
        "step1Name": "Organización",
        "step2Name": "Conectores",
        "organizationNameDescription": "Selecciona la empresa a la que se deben asignar nuevos conectores",
        "organizationNameLabel": "Nombre de la organización",
        "organizationPlaceholder": "Selecciona la organización",
        "inviteParticipantDescription": "O haz clic en el botón de invitar participante para invitar a una nueva empresa a colaborar en el dataspace",
        "inviteParticipantButton": "Invitar participante",
        "numberOfConnectorsDescription": "Elige el número de conexiones",
        "numberOfConnectorsLabel": "Número de conectores",
        "numberOfConnectorsPlaceholder": "Cantidad",
        "progressBarDescription": "Cuota de conectores",
        "progressBarInfo": "{numberOfConnectors} conectores disponibles",
        "allocateButtonLabel": "Asignar",
        "cancelButtonLabel": "Cancelar",
        "noConnectorRemaining": "Todos los conectores están en uso. Por favor, haz clic en 'Recargar conectores' para discutir la extensión de los conectores con nuestro equipo."
      },
      "successRequestTest": "Solicitud exitosa",
      "successRequestBody": "La asignación de conectores se ha iniciado con éxito",
      "decisionModal": {
        "title": "Has sido invitado a unirte a {dataspaceName}",
        "accept": "Aceptar",
        "decline": "Rechazar",
        "acceptSuccessNotificationTitle": "¡Aceptación exitosa!",
        "acceptSuccessNotificationBody": "Has aceptado con éxito la invitación para unirte a {dataspaceName}.",
        "declineSuccessNotificationTitle": "¡Invitación rechazada!",
        "declineSuccessNotificationBody": "Has rechazado la invitación para unirte a {dataspaceName}."
      }
    },
    "request": {
      "requestTitle": "Dé el siguiente paso en el intercambio de datos y cree su propio espacio de datos!",
      "requestDescription1": "¿Quiere no sólo compartir sus propios datos, sino también permitir que sus socios comerciales compartan datos entre sí? En ese caso, plantéese crear un espacio de datos, que es una comunidad de confianza para compartir o monetizar datos.",
      "requestDescription2": "T-Systems configurará y pondrá en funcionamiento su espacio de datos en nuestra infraestructura de confianza.",
      "requestDescription3": "También ofrecemos configuraciones de prueba limitadas para que pueda familiarizarse con los espacios de datos („LivingLab“).",
      "request": "Solicitar",
      "sendAnotherRequest": "Enviar otra solicitud",
      "lastRequest": "Su última solicitud se envió el",
      "back": "Volver atrás",
      "sendRequest": "Enviar solicitud",
      "requestedTextPlaceholder": "¿Está buscando algo en concreto o desea hacer una consulta general? ¿Tiene experiencia con espacios de datos? ¿Está interesado en una configuración de prueba?",
      "visitorAnalyticsPro": {
        "title": "Solicitar Visitor Analytics PRO de Motion Data",
        "placeholder": "¿Está buscando algún producto específico o consultoría general para sus necesidades de datos? ¿Alguna experiencia previa con los productos de Motion Data? ¿Interesado en una demostración?"
      }
    },
    "create": {
      "createTitle": "Cree su propio espacio de datos",
      "createDesc": "Puede enviar una solicitud a nuestro equipo de expertos y nos pondremos en contacto con usted.",
      "tellUsMore": "¿Podría decirnos algo más sobre su solicitud?"
    },
    "details": {
      "approve": "Aprobar",
      "decline": "Rechazar",
      "approval": "Aprobación",
      "requesterNotes": "Notas del solicitante",
      "adminNotes": "Notas del administrador",
      "decisionTakenTooltip": "La aceptación o el rechazo ya han ocurrido. La provisión de los conectores se está preparando actualmente. Se te informará tan pronto como se hayan completado.",
      "decisionInputPlaceholder": "Notas para la aprobación o denegación ...",
      "activeParticipants": "Participantes activos",
      "incomingRequests": "Solicitudes entrantes",
      "invitations": "Invitaciones",
      "manage": "Gestionar",
      "enter": "Introducir",
      "providedBy": "Provisto por",
      "registered": "Registrado",
      "operatorToolkit": "Kit de herramientas del operador",
      "noOperatorToolkit": "No tienes herramientas habilitadas en el kit de operador.",
      "errorOperatorToolkit": "Error al obtener los detalles del kit de operador",
      "dataspaceDetails": "Detalles del espacio de datos",
      "contactDetails": "Detalles de contacto",
      "visibilityTitle": "Ocultar tu dataspace de la lista de dataspace navegables",
      "manageParticipants": "Gestionar participantes",
      "applicationManagement": "Gestión de aplicaciones",
      "networkManagement": "Gestión de red",
      "noApplications": {
        "title": "Todavía no tienes aplicaciones",
        "actionButtonText": "Registrar aplicación"
      },
      "contactUs": "Si desea actualizar algún dato, póngase en contacto con nosotros directamente",
      "noData": "Todavía no tienen datos",
      "basic": "Básico",
      "companyName": "Nombre de la empresa",
      "participantName": "Nombre del participante",
      "participationMode": "Modalidad de participación",
      "connectorName": "Nombre del conector",
      "connectorVariant": "Variante de conector",
      "contact": "Contacto",
      "address": "Dirección",
      "street": "Calle",
      "number": "Número",
      "postalCode": "Código postal",
      "city": "Ciudad",
      "country": "País",
      "phoneNo": "Número de teléfono",
      "contactPerson": "Persona de contacto",
      "email": "Correo electrónico",
      "dateOfJoining": "Fecha de incorporación",
      "dateOfInvitation": "Fecha",
      "operator": "Operador",
      "dateOfRequest": "Fecha de solicitud",
      "url": "URL",
      "status": "Estado",
      "bpn": "Número de socio comercial",
      "name": "Nombre",
      "description": "Descripción",
      "website": "Página web",
      "dataspaceId": "ID del espacio de datos",
      "password": "Contraseña",
      "digitalId": "Este espacio de datos está habilitado para Digital.ID",
      "disableDigitalId": "Digital.ID no está habilitado para este espacio de datos",
      "company": "Empresa | Empresas",
      "connector": "Conector | Conectores",
      "application": "Aplicación | Aplicaciones",
      "dataoffer": "Oferta de datos | Ofertas de datos",
      "visibility": "Su espacio de datos es ahora {access}",
      "discoverable": "Descubrible",
      "private": "Privado",
      "statusTooltip": {
        "invited": "Se ha enviado la invitación para unirse al espacio de datos",
        "inprogress": "El invitado ha enviado el formulario de incorporación",
        "expired": "La invitación ha caducado debido a 14 días de inactividad",
        "withdrawn": "Se ha retirado la invitación",
        "rejected": "La solicitud de incorporación ha sido rechazada. Por favor, póngase en contacto con dih.support{'@'}telekom.com para obtener más detalles",
        "active": "El participante se ha incorporado correctamente",
        "failed": "Fallido"
      },
      "deleteParticipant": {
        "modal": {
          "title": "Eliminar participante",
          "informationText": "El conector perteneciente al participante se desplegará al confirmar. Esta acción no se puede deshacer.",
          "successNotificationTitle": "Solicitud de Eliminación",
          "successNotificationBody": "Se ha solicitado la eliminación de un participante",
          "cancel": "Cancelar",
          "delete": "Eliminar"
        }
      },
      "services": {
        "applicationOrchestration": "Orquestación de aplicaciones",
        "applicationOrchestrationDesc": "Implementa y gestiona tus aplicaciones empresariales",
        "identityAccessManagement": "Gestión de identidades y accesos",
        "identityAccessManagementDesc": "Gestione sus usuarios y su acceso a los recursos",
        "continuousDelivery": "Entrega continua",
        "continuousDeliveryDesc": "Adopte las mejores prácticas de implementación y operaciones",
        "secretCredentialManagement": "Gestión de secretos y credenciales",
        "secretCredentialManagementDesc": "Proteja, almacene y controle el acceso a tokens, contraseñas y certificados",
        "monitoring": "Seguimiento",
        "monitoringDesc": "Consulte, visualice, reciba alertas y comprenda sus métricas y KPIs",
        "connectorTest": "Comprobación de salud del conector",
        "connectorTestDesc": "Servicio para ejecutar una comprobación de salud para los conectores.",
        "catenaXSandbox": "Catena-X Sandbox",
        "catenaXSandboxDesc": "Inicie su sandbox Catena-X dentro de su LivingLab para desarrollar y probar sus nuevas aplicaciones empresariales en el entorno Catena-X."
      }
    },
    "connectorHealthCheck": {
      "title": "Comprobación de salud del conector",
      "viewResults": "Ver resultados",
      "close": "Cerrar",
      "description": "Elige uno o más conectores para ejecutar una comprobación de salud. Las operaciones estándar del dataspace no se verán afectadas por la comprobación de salud.",
      "connectors": "conectores",
      "placeholder": "Elige conectores",
      "searchInputLabel": "Buscar conectores...",
      "banner": "La comprobación de salud puede tardar unos minutos en ejecutarse. Se te notificará tan pronto como el resultado esté disponible.",
      "action": "Iniciar",
      "history": {
        "connectorName": "Nombre del conector",
        "initiated": "Iniciado",
        "completed": "Completado",
        "result": "Resultado",
        "successMessage": "{connectorName} está funcionando como se espera",
        "unsuccessfulMessage": "{connectorName} no está funcionando como se espera. Por favor, contacta a "
      },
      "successNotificationTitle": "Comprobación de salud del conector iniciada.",
      "successNotificationContent": "Se te notificará cuando el resultado esté disponible.",
      "noTest": "Todavía no tienes pruebas",
      "initiateTest": "Iniciar prueba"
    },
    "specifications": {
      "table": {
        "attribute": "Atributo",
        "value": "Valor",
        "cloudProvider": "Proveedor de nube",
        "contractStart": "Inicio del contrato",
        "contractDuration": "Duración del contrato",
        "cpu": "CPU",
        "ram": "RAM",
        "storage": "Almacenamiento",
        "maximumConnectorsBookable": "Conectores máximos reservables",
        "subscribedConnectors": "Conectores suscritos"
      },
      "dataspaceSpecifications": "Especificaciones del espacio de datos",
      "livinglabCore": "Núcleo de LivingLab",
      "livinglabAppLayer": "Capa de aplicación de LivingLab"
    },
    "connectorManagement": {
      "connectorManagement": "Conectores",
      "connectorName": "Nombre del conector",
      "connectorType": "Tipo de conector",
      "targetParticipant": "Participante objetivo",
      "connectorOwner": "Propietario del conector",
      "url": "URL",
      "status": "Estado",
      "connectorUrl": "URL del conector",
      "connectorUiUrl": "URL de la interfaz del conector",
      "connectorRegistration": "Registro de conectores",
      "connectorDeployment": "Despliegue de conectores",
      "technicalUser": "Usuario técnico",
      "selfDescRegistration": "Registro de autodescripción",
      "connectorDeleteTitle": "¿Está seguro de que desea eliminar el conector?",
      "connectorDeleteDescription": "Tenga en cuenta: Esta acción no elimina ni detiene la instancia de conector real que se ejecuta en su infraestructura. Una vez eliminado, este conector ya no aparecerá en el Portal DIH ni estará disponible para transacciones de datos dentro de este espacio de datos hasta que se vuelva a registrar.",
      "deleteSuccessMessage": "Conector eliminado correctamente",
      "saveSuccessMessage": "Detalles del conector actualizados correctamente",
      "registerConnector": "Registrar propio conector",
      "howToConfigure": "Cómo configurar su conector",
      "howToDescription": "La información a continuación proporciona los valores de configuración necesarios para registrar y luego desplegar tu conector externo. Estas configuraciones permiten que tu conector se autentique correctamente e interactúe con los servicios de Dataspace.",
      "howToDescription1": "Antes del despliegue, tu conector debe estar registrado en el Dataspace. Este flujo cubre el paso de registro. Los campos URL que introducirás en los próximos pasos podrán editarse más adelante, por lo que puedes continuar incluso si algunos endpoints aún no son definitivos.",
      "supportedEDCVersions": "Versiones de EDC soportadas:",
      "howToInfo": {
        "info1": "iatp.sts.oauth.client.id: ID de cliente del usuario técnico para este conector específico.",
        "info2": "iatp.sts.oauth.client.secret: Secreto del usuario técnico para este conector específico.",
        "info3": "Ambos valores mencionados estarán disponibles una vez completado el registro del conector. Puedes desplegar el conector tras completar el proceso de registro."
      },
      "connectorRegistationTitle": "Detalles de registro del conector",
      "location": "Ubicación*",
      "locationError": "Se requiere localización",
      "connectorRegistrationProgress": "Registro del conector en progreso",
      "connectorCatalogEndpoint": "Endpoint del Catálogo de Conectores*",
      "connectorUIEndpoint": "Endpoint de UI del Conector (opcional)",
      "connectorRegistrationInfo": "El estado de registro del conector se puede verificar en la sección de gestión de conectores del espacio de datos.",
      "viewConfiguration": "Configuración de visualización",
      "name": "Nombre",
      "value": "Valor",
      "stepToDeployConnector": "Pasos para desplegar un conector:",
      "deploymentGuide": "Guía de despliegue de conectores",
      "clientIdDummyValue": "ID de cliente de tu usuario técnico para el conector",
      "secreteDummyValue": "Secreto del usuario técnico para el conector",
      "failedConnectorDeploymentTooltip": "El conector no está disponible actualmente. Despliegue pendiente."
    }
  },
  "profile": {
    "profile": "Perfil",
    "userProfile": "Perfil de usuario",
    "personalInfo": "Información personal",
    "personalDetails": "Datos personales y configuración",
    "changeDetailsMessage": "Si desea cambiar algún dato, por favor, póngase en contacto con nosotros",
    "changeDetailsLinkText": "Asistencia",
    "memberships": "Suscripciones",
    "security": "Seguridad",
    "setUp2FA": "Configurar 2FA",
    "accountInformation": "Información sobre la cuenta",
    "deleteAccount": "Eliminar cuenta de usuario",
    "deleteAccountDescription": "Con esta acción, se eliminarán todos los datos y los archivos de datos asociados a su cuenta personal.",
    "accountSecurity": "Seguridad de la cuenta",
    "yourInfomration": "Su información",
    "fullName": "Nombre completo",
    "contact": "Contacto",
    "language": "Idioma",
    "changePassword": "Cambiar contraseña",
    "please": "Por favor",
    "contactSupport": "Contactar con el equipo de asistencia",
    "toDownload": "Para descargar esta información",
    "toDelete": "Para eliminar su perfil",
    "roles": "Roles",
    "memberSince": "Miembro desde",
    "orgLegalName": "Nombre legal de la organización",
    "bpnNumber": "Número de socio comercial",
    "commRegNumber": "Número de registro comercial",
    "vatIdNumber": "Número de IVA",
    "hqAddress": "Dirección de la sede principal",
    "legalIdentifier": "Identificador legal",
    "additionalAttributes": "Atributos adicionales",
    "languageSwitcherMessage": "Parte de esta página ha sido traducida por máquina o IA. ¿Crees que se puede mejorar? Cuéntanos en dih.support{'@'}telekom.com."
  },
  "plansBenefits": {
    "communicationIntegrity": "Integridad de la comunicación",
    "protectedConnection": "Conexión protegida",
    "mutualAuth": "Autenticación mutua",
    "stateArtOfCrypto": "Criptografía de última generación",
    "remoteAttestation": "Atestación a distancia",
    "platforInt": "Integridad de la plataforma",
    "configureAndApp": "Configuración e integración de la aplicación",
    "dataUsageControl": "Control del uso de datos",
    "definitionOfUsagePolicy": "Definición de la política de uso",
    "from": "desde",
    "month": "mes",
    "connect": "Conectar"
  },
  "cookieSettings": {
    "collapsedTitle": "Configuración de privacidad",
    "collapsedText": "Este sitio web utiliza cookies y tecnologías similares. Son pequeños archivos de texto que se almacenan y leen en su computadora. Al hacer clic en '{0}', acepta el procesamiento, la creación de perfiles de usuario individuales en sitios web y socios, y la transferencia de sus datos a terceros, algunos de los cuales procesan sus datos en países fuera de la Unión Europea (RGPD Art. 49). Los detalles se pueden encontrar en la sección 2 de la {1}. Los datos se utilizan para análisis, retargeting y para reproducir contenido publicitario y publicidad personalizados en sitios de Telekom y sitios de terceros. Puede encontrar más información, incluida información sobre el procesamiento de datos por parte de proveedores de terceros y la posibilidad de revocación, en la configuración y en nuestra información de privacidad. Aquí puede {2} solo con las herramientas necesarias.",
    "extendedTitle": "Configuración de privacidad",
    "extendedText": "Para proporcionarle una experiencia óptima en el sitio web, utilizamos cookies. Estas incluyen cookies para el funcionamiento y la optimización del sitio, así como para servicios como chat de texto o video y para publicidad basada en su comportamiento de uso en línea. Esto nos permite, por ejemplo, detectar si visita nuestras páginas repetidamente desde el mismo dispositivo. Nos gustaría darle la opción de qué cookies permite:",
    "onlyRequired": "Solo es necesario",
    "policyLinkHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkCookieHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkTextShort": "información sobre privacidad",
    "policyLinkText": "Información sobre privacidad",
    "rejectLinkText": "continuar",
    "acceptButton": "Aceptar todo",
    "saveButton": "Guardar configuración",
    "settingsButton": "Cambiar configuración",
    "showMore": "Mostrar más",
    "showLess": "Mostrar menos",
    "categoryTitleEssential": "Cookies necesarias",
    "categoryTitleAnalytics": "Cookies analíticas",
    "categoryTitleMarketing": "Cookies de marketing",
    "categoryTitleThirdParty": "Servicios proporcionados por otras empresas (proveedores externos independientes)",
    "categoryTextEssential": "Estas cookies son necesarias para permitirle navegar por los sitios web y utilizar funciones clave. Apoyan funciones básicas, como el procesamiento de pedidos en la tienda en línea y el acceso a áreas seguras de la página web. También sirven para realizar un análisis anónimo de los patrones de usuario, que utilizamos para desarrollar y mejorar continuamente nuestras páginas web para usted.",
    "categoryTextAnalytics": "Estas cookies nos ayudan a mejorar nuestra comprensión del comportamiento del usuario. Las cookies de análisis permiten la recopilación de datos de uso e identificación por parte del proveedor original o proveedores de terceros en perfiles de uso seudónimos. Usamos cookies de análisis, por ejemplo, para determinar el número de visitantes individuales a una página web o un servicio, para recopilar datos estadísticos sobre el rendimiento de nuestros productos y para analizar los patrones de uso y las interacciones de los visitantes en función de información anónima y seudónima. Esta información no se puede rastrear hasta una persona.",
    "categoryTextMarketing": "Estas cookies y tecnologías similares se utilizan para permitir la visualización de contenido de marketing personalizados y, por tanto, relevantes. Las cookies de marketing se utilizan para mostrar contenido publicitario interesante y para medir la eficacia de nuestras campañas. Esto ocurre no sólo en las páginas web de Telekom, sino también en los de otros socios publicitarios (proveedores externos). Esto también se denomina \"retargeting\". Se utiliza para crear perfiles de contenido o anuncios seudónimos, mostrar publicidad relevante en otras páginas web y obtener información sobre los públicos objetivos que han visto los anuncios y contenido. A partir de estos análisis no es posible extraer crelacionar la información con ninguna persona. Las cookies de marketing y las herramientas de retargeting nos ayudan a ofrecerle contenidos publicitarios potencialmente relevantes para usteed. Si desactiva las cookies de marketing, seguirá viendo el mismo número de anuncios, pero éstos pueden ser menos relevantes para usted.",
    "categoryTextThirdParty": "Las páginas web de Telekom incluyen enlaces a proveedores de servicio externos, que prestan sus servicios bajo su propia responsabilidad. Cuando visita páginas web de Telekom, se recopilan datos mediante cookies u otras tecnologías similares y se transmiten a los proveedores externos correspondientes, en parte para fines propios de Telekom. El alcance, finalidad y base jurídica sobre la que se lleva a cabo el tratamiento posterior para los propios fines del tercero pueden consultarse en la política de privacidad de los proveedores externos. La información sobre proveedores externos independientes puede encontrarse en la información sobre privacidad de datos."
  },
  "consultation": {
    "createDescription": "Puede enviar una solicitud a nuestro equipo de expertos y nos comunicaremos con usted.",
    "tellUsMore": "¿Puede contarnos más sobre su solicitud?",
    "checkConsent": "Doy mi consentimiento para que mis datos de contacto se proporcionen a un equipo de ventas de T-Systems y para que me contacten.",
    "back": "Atrás",
    "sendRequest": "Enviar petición",
    "successMsgtitle": "¡Solicitud exitosa!",
    "successMsgBody": "Tu solicitud ha sido enviada... recibirás respuesta en unos días laborables"
  },
  "notifications": {
    "notifications": "Notificaciones",
    "inbox": "Bandeja de entrada",
    "clearAll": "Borrar todo",
    "blankState": {
      "heading": "Aún no hay notificaciones",
      "description": "Cuando reciba notificaciones, aparecerán aquí",
      "actionButtonText": "Actualizar"
    },
    "actionMessage": {
      "seeRequest": "Ver la solicitud",
      "here": "aquí",
      "checkResult": "Verificar el resultado "
    },
    "goToMyAccount": "Por favor, consulte la información sobre su(s) nuevo(s) rol(es) en {myAccountLink}."
  },
  "statusTile": {
    "noMembership": {
      "title": "Todavía no tiene ninguna suscripción",
      "subTitle": "Explorar espacios de datos para unirse a uno",
      "getConnected": "Conectarse"
    }
  },
  "settings": {
    "organization": {
      "pageTitle": "Mi organización",
      "orgDetails": "Detalles de la organización",
      "teamMembers": "Miembros del equipo",
      "groups": "Grupos",
      "groupsOverview": "Resumen de los grupos",
      "technicalUsers": "Usuarios técnicos",
      "singleSignOn": "Inicio de sesión único",
      "mapGroupClaims": "Ansprüche der Map Group"
    },
    "teamMembers": {
      "title": "Gestión de usuarios",
      "description": "Esta sección le ayuda a gestionar los usuarios de su organización"
    },
    "groups": {
      "title": "Gestión del grupo",
      "description": "Los grupos representan departamentos dentro de tu organización. Un usuario en un grupo siempre es también miembro de la organización principal.",
      "createGroup": "Crear grupo",
      "groupName": "Nombre del grupo",
      "groupDesc": "Descripción del grupo",
      "groupCreateNote": "Los miembros pueden ser asignados a este grupo tras la creación. Solo se pueden añadir miembros existentes de la organización.",
      "membersTitle": "Miembros",
      "members": "miembro(s)",
      "createdBy": "Creado por",
      "createdOn": "Creado en",
      "contactPerson": "Persona de contacto",
      "actions": "Acciones",
      "groupMembers": "Miembros del grupo",
      "groupDetails": "Detalles del grupo",
      "groupMembersDescription": "Asigna a los miembros existentes de la organización a este grupo",
      "disableAddMembers": "La pertenencia al grupo se gestiona mediante claims de SSO. Utilice su proveedor de identidad para gestionar el acceso al grupo.",
      "addMembers": "Añadir miembros",
      "fullName": "Nombre completo",
      "addedToGroup": "Añadido al grupo",
      "addMembersTo": "Añadir miembros a “{name}”",
      "addToGroup": "Añadir al grupo",
      "addMemberDescription": "Selecciona entre los miembros de tu organización. Los miembros seleccionados también seguirán siendo miembros de la organización principal.",
      "membersSelected": "miembros(es) seleccionados",
      "editSuccess": "Detalles del grupo editados con éxito",
      "addMemberSuccess": "Usuario(s) seleccionado(s) añadido(s) al grupo con éxito",
      "duplicateGroupNameError": "Ya existe un grupo con este nombre. Por favor, elige otro nombre."
    },
    "inviteUser": {
      "inviteUsers": "Invitar usuarios",
      "newEmailAddress": "Dirección de correo electrónico de nuevos miembros del equipo",
      "chooseRole": "Elegir rol",
      "whichRoleToSelect": "¿Qué rol debo seleccionar?",
      "roleNote": "El rol seleccionado se asignará a todos los usuarios invitados",
      "roleError": "Por favor, seleccione al menos 1 rol de las opciones disponibles",
      "roleErrorShort": "Por favor, seleccione al menos 1 rol",
      "cancel": "Cancelar",
      "sendInvite": "Enviar invitación",
      "fullName": "Nombre completo",
      "status": "Estado",
      "role": "Rol",
      "memberSince": "Miembro desde"
    },
    "inviteSuccess": {
      "title": "Resumen de la invitación",
      "totalInvitation": "{count} invitación enviada | {count} invitaciones enviadas",
      "description": "{count} invitación no se envió porque la dirección de correo electrónico ya existe en el Data Intelligence Hub | {count} invitaciones no se enviaron porque las direcciones de correo electrónico ya existen en el Data Intelligence Hub",
      "actionContinue": "Continuar"
    },
    "roleChange": {
      "areYouSure": "¿Estás seguro de que quieres hacer estos cambios de rol?",
      "yeahSure": "Sí, estoy seguro"
    },
    "technicalUser": {
      "title": "Credenciales técnicas de usuario",
      "createdAt": "creado en",
      "clientId": "ID del cliente",
      "clientSecret": "Cliente Secreto",
      "sendCredEmailBtn": "Envía credenciales a mi correo electrónico",
      "sendCredEmailDescription": "Se enviará un correo electrónico con sus credenciales a su dirección de correo. Por favor, revisa tu bandeja de entrada en unos minutos.",
      "use": "usar el",
      "clipboardText": "icono para copiar el ID del cliente al portapapeles.",
      "successText": "Se ha enviado con éxito un correo electrónico con tus credenciales a tu dirección de correo",
      "actions": "acciones"
    },
    "sso": {
      "description": "Conecte el proveedor de identidad de su organización para habilitar el inicio de sesión basado en SSO.",
      "microsoftEntraId": "Microsoft EntraID",
      "tenantId": "ID del inquilino:",
      "clientId": "ID del cliente:",
      "redirectURI": "URI de redirección:",
      "groupClaimMappings": "Asignaciones de claims de grupos",
      "autoAssign": "Asignar automáticamente usuarios a grupos de según los claims del token del identity provider.",
      "setupGroupClaims": "Configurar claims de grupos",
      "noIdentityProviderConfigured": "No hay ningún proveedor de identidad configurado",
      "contact": "Póngase en contacto con dih.support{'@'}telekom.com para configurar un proveedor de identidad externo.",
      "claimName": "Nombre de la reclamación",
      "mappings": "Asignaciones",
      "idpClaimValue": "Valor de la reclamación del Identity Provider",
      "dihGroups": "Grupos",
      "groupMappingDisclaimer": "Todos los usuarios asignados reciben el rol de usuario empresarial de forma predeterminada.",
      "groupClaimNameDescription": "Mapear los valores de los grupos desde el token identity provider a los grupos en el portal.", 
      "claimNameDisclaimer": "La clave en el token identity provider que lleva los valores del grupo.", 
      "claimNameLabel": "Grupos reclaman nombre en token *", 
      "noMappingHeading": "Aún no se definen mapeos", 
      "noMappingSubheading": "Añadir un mapeo para asignar automáticamente a los usuarios a grupos.",
      "addMapping": "Añadir mapeo", 
      "businessUserDisclaimer": "Todos los usuarios mapeados se asignan como Business-User por defecto.",
      "businessUserDisclaimer2": "La asignación de roles se gestiona por separado.", 
      "reviewChanges": "Cambios en la reseña", 
      "confirmSave": "Confirmar & guardar", 
      "confirmModalDisclaimer1": "Los cambios entran en vigor en el siguiente inicio de sesión de usuario tras guardar.", 
      "confirmModalDisclaimer2": "Los usuarios actualmente asignados no serán eliminados hasta su próximo inicio de sesión.", 
      "confirmBeforeSaving": "Confirma los siguientes cambios en el mapeo antes de guardar."
    }
  },
  "completeInviteProfile": {
    "title": "Complete su cuenta",
    "description": "Ha sido invitado a Telekom Data Intelligence Hub. Para completar su cuenta, por favor, rellene la información necesaria.",
    "firstName": "Nombre",
    "firstNamePlaceholder": "Introduzca su nombre",
    "lastName": "Apellidos",
    "lastNamePlaceholder": "Introduzca sus apellidos",
    "email": "Correo electrónico",
    "emailPlaceholder": "Introduzca su correo electrónico",
    "organisation": "Organización",
    "organisationPlaceholder": "Introduzca su organización",
    "enterPassword": "Introduzca su contraseña",
    "dataPrivacyCheck": "Apruebo que mis datos personales se almacenen y procesen de acuerdo con los fines indicados en la {dataAndPrivacyStatement}.* ",
    "termsAndConditionsCheck": "Confirmo que he leído y cumpliré los {termsandcondition} de Data Intelligence Hub.",
    "termsandcondition": "Términos y condiciones",
    "dataAndPrivacyStatement": "Declaración de privacidad de datos",
    "cancel": "Cancelar",
    "submit": "Enviar",
    "success": {
      "title": "Su cuenta ha sido completada",
      "description": "Se le redirigirá a la página de inicio de sesión",
      "actionContinue": "Continuar"
    }
  },
  "workbench": {
    "incomingDataAgreements": {
      "title": "Acuerdos sobre datos entrantes",
      "addedOn": "Añadido el",
      "expiresOn": "Expira el",
      "providedBy": "Proporcionado por",
      "dateAddedOn": "Fecha de incorporación",
      "noFilesAttached": "No hay archivos adjuntos actualmente a este acuerdo contractual",
      "noAgreementsMessage": "No tiene acuerdos de datos entrantes",
      "receivingData": "Recibiendo datos",
      "dataReceived": "Descargado",
      "error": "Error ocurrido",
      "transferInitiated": "Transferencia iniciada",
      "transferCompleted": "¡Transferencia completada!",
      "view": "Ver",
      "successDownload": "El activo de datos se recibió correctamente",
      "errorDownload": "Tu descarga de archivos para {filename} se abortó con un error, por favor inténtalo de nuevo",
      "viewAggreement": "Ver acuerdo",
      "agreeText": "Al descargar los archivos, aceptas cumplir con los {contractTerms} de este acuerdo",
      "contractTerms": "Términos del contrato",
      "includedFile": "Archivo incluido",
      "createdOn": "Creado el",
      "fileType": "Tipo de archivo",
      "downloadError": "Error al recuperar acuerdos de datos entrantes",
      "downloadSuccess": "El activo de datos se recibió correctamente"
    },
    "contractDetails": {
      "termsAndPolicies": "Términos y políticas",
      "offerBy": "Ofrecido por",
      "addedOn": "Agregado el",
      "expiresOn": "Caduca el",
      "product": "Producto",
      "totalFiles": "Total de archivos",
      "description": "Descripción",
      "contractID": "ID de contrato",
      "contractTerms": "Términos del contrato",
      "files": "Archivos",
      "parameters": "Parámetros",
      "referencePeriod": "Período de referencia",
      "location": "Ubicación",
      "additionalLinks": "Enlaces adicionales",
      "dihMainPage": "Página principal de DIH",
      "download": "Descargar",
      "search": "Buscar",
      "title": "Título",
      "createdOn": "Creado el",
      "kpiName": "Nombre del KPI",
      "fileType": "Tipo de archivo",
      "schema": "Esquema",
      "dashboard": "Tablero",
      "selectAll": "Seleccionar todo",
      "deselectAll": "Deseleccionar todo",
      "transfer": "Transferencia",
      "downloadSelected": "Descargar seleccionado",
      "noTermsPolicy": "En este momento, el Proveedor de Datos no ha especificado ninguna regla para el uso de datos dentro de este contrato.",
      "youCan": "Puedes",
      "youCant": "No puedes",
      "youMust": "Debes",
      "respectContent": "Respetar el contenido del Acuerdo de Licencia",
      "licenceAgreement": "Acuerdo de Licencia",
      "noAttachment": "Aún no hay adjuntos",
      "termsandcondition": "Términos y condiciones",
      "resellData": "Revender los datos",
      "youCanUseDataCommercial": "Usar los datos con fines comerciales",
      "youCanProcessData": "Procesar los datos en infraestructura fuera de la Unión Europea",
      "youCanEmpty": "En este momento, el Proveedor de Datos no ha especificado ningún permiso para el uso de datos dentro de este contrato",
      "youCantEmpty": "En este momento, el Proveedor de Datos no ha especificado ninguna prohibición para el uso de datos dentro de este contrato",
      "youMustEmpty": "En este momento, el Proveedor de Datos no ha especificado ninguna obligación para el uso de datos dentro de este contrato"
    }
  },
  "messages": {
    "noDataAvailable": "No hay datos disponibles",
    "noMatchFound": "No se ha encontrado ninguna coincidencia",
    "maximumFileSize": "Tamaño máximo de archivo",
    "suitableFileFormats": "Formatos de archivo válidos",
    "loading": "Cargando...",
    "dragDropText": "o arrástralo aquí"
  },
  "pageNotFound": {
    "title": "¡Oops! Parece que la página que estás buscando aún no existe.",
    "subtitle": "¡Mientras tanto, echa un vistazo a nuestros otros recursos, que podrían ser útiles para ti!"
  },
  "unauthorized": {
    "pageNotAccessible": "¡Vaya! Parece que no se puede acceder a la página que está buscando con sus permisos.",
    "reachOutToAdministrator": "Póngase en contacto con su administrador para obtener más información sobre su acceso.",
    "checkOtherResources": "Mientras tanto, consulte nuestros otros recursos."
  },
  "helpResources": {
    "needHelp": "¿Necesita ayuda para encontrar el plan adecuado, más información, preguntas técnicas?",
    "FAQ": "Preguntas frecuentes",
    "FAQDescription": "Encuentra respuestas comunes desde facturación hasta privacidad",
    "browse": "Navegar",
    "demos": "Demos",
    "demosDescription": "Encuentra casos de uso y demos relevantes para tu sector industrial",
    "glossary": "Glosario",
    "glossaryDescription": "Encuentra los términos y definiciones relacionados con Data Intelligence Hub, IDSA, Catena-X, Gaia-X y más."
  },
  "feedbackCard": {
    "giveUsFeedback": "¿Dinos qué nos falta?",
    "contactUs": "Contáctanos"
  },
  "requestDataspaceJoin": {
    "title": "Solicitar conexión a {dsName}",
    "basic": "Básico",
    "orgName": "Nombre de la organización:",
    "contact": "Contacto",
    "address": "Dirección:",
    "name": "Nombre:",
    "email": "Correo electrónico:",
    "joinReasonTitle": "Por favor, indica por qué quieres unirte al dataspacio?",
    "joinConsent": "Consiento compartir los detalles anteriores con el propietario del dataspacio",
    "sendRequest": "Enviar solicitud"
  },
  "applications": {
    "myApplication": "Mis Aplicaciones"
  },
  "externalConnection": {
    "title": "Administrador de Conexiones Externas",
    "noConnectionConfigureTitle": {
      "title": "Todavía no has configurado ninguna conexión",
      "newConnection": "Nueva Conexión"
    },
    "request": {
      "connectionDetails": "Detalles de la conexión",
      "preferConnection": "Selecciona el modo preferido de conexión al servidor",
      "selectConnection": "Seleccionar Conexión",
      "ageeTerms": "Por la presente, acepto y confirmo que toda mi información personal y datos indicados anteriormente son precisos",
      "grantConsent": "Doy mi consentimiento a Telekom Data Intelligence Hub para el procesamiento y almacenamiento de estos datos para facilitar transferencias de activos a través de la conexión proporcionada",
      "back": "Atrás",
      "addConnection": "Agregar Conexión",
      "save": "Guardar",
      "verifyConnectivity": "Verificar Conectividad",
      "checkingConnection": "Verificando conexión",
      "connectionVerified": "Conexión verificada",
      "error": "Error",
      "requestSuccessTitle": "¡Agregado exitosamente!",
      "requestSuccessText": "Has agregado exitosamente los detalles de tu conexión.",
      "requestUpdatedTitle": "¡Actualizado exitosamente!",
      "requestUpdatedText": "Has actualizado exitosamente los detalles de tu conexión.",
      "maxConnectionReached": "Has alcanzado el número máximo de conexiones gratuitas."
    },
    "delete": {
      "title": "Eliminación de conexión",
      "description": "¿Estás seguro de que quieres eliminar esta conexión?",
      "cancel": "Cancelar",
      "delete": "Eliminar",
      "requestDeleteSuccessTitle": "¡Eliminado con éxito!",
      "requestDeleteSuccessText": "Has eliminado exitosamente tu conexión."
    },
    "transfer": {
      "title": "Administrador de conexiones",
      "connectionDetails": "Detalles de la conexión",
      "type": "Tipo",
      "hostName": "Nombre de host",
      "rootPath": "Ruta raíz",
      "authType": "Tipo de autenticación",
      "username": "Nombre de usuario",
      "verificationStatus": "Estado de verificación",
      "disclaimer": "Renuncia",
      "disclaimerText": "Al confirmar su selección, reconoce que la conexión elegida está fuera del control de Telekom Data Intelligence Hub. En consecuencia, usted asume la responsabilidad de cualquier problema en la transferencia de datos que surja de factores externos, incluidos, entre otros, almacenamiento insuficiente, conectividad de red, restricciones de acceso y autenticación, y otras consideraciones relevantes.",
      "confirmSelection": "Confirmar selección",
      "newConnection": "Nueva conexión",
      "noConnectionModalTitle": "Todavía no tienes conexiones",
      "noConnectionModalDesc": "Puede crear una nueva conexión haciendo clic en el botón de abajo.",
      "noConnectionAddNewButton": "Agregar nueva conexión",
      "successModalTitle": "La transferencia tardará más de lo habitual",
      "successModalDesc": "Enviaremos una notificación una vez que se complete la transferencia de archivos.",
      "successModalAction": "Ir a Entrada de datos"
    }
  },
  "error": {
    "pageNotFound": "Página no encontrada (404)",
    "unauthorized": "Acceso no autorizado (403)"
  },
  "helpWidget": {
    "askSupport": "Solicitar asistencia",
    "chatboxTitle": "Chat de ayuda",
    "chatboxSubtitle": "Soporte de Telekom Data Intelligence Hub",
    "defaultMessage": {
      "body": "Hola, bienvenido al canal de soporte de Telekom Data Intelligence Hub. Por favor, selecciona una opción a continuación."
    },
    "whatCanWeHelpWith": "¿En qué podemos ayudarte hoy?",
    "suggestedAnswers": {
      "knowledgeBase": "Base de conocimientos, documentación y preguntas frecuentes",
      "contactSupport": "Contactar soporte",
      "contactSales": "Contactar ventas"
    }
  },
  "partnerNetworkManagement": {
    "title": "Gestión de la red de socios",
    "hint": "Esta página permitirá a los usuarios invitar y supervisar el estado de la invitación de sus organizaciones asociadas a Telekom Data Intelligence Hub",
    "noInvitations": {
      "title": "Aún no ha invitado a ninguna organización",
      "actionButtonText": "Invitar a una organización"
    },
    "overview": {
      "title": "Resumen de invitaciones de socios",
      "actionButtonText": "Invitar organizaciones",
      "dateOfInvitation": "Fecha de la invitación",
      "resendInvitation": "Reenviar invitación",
      "deleteInvitation": "Eliminar invitación",
      "resendReminderInfo": "Puedes reenviar la invitación en cuanto hayan pasado 24 horas desde el último correo electrónico de invitación.",
      "invitedBy": "Invitado por"
    },
    "information": {
      "title": "Información importante",
      "description": "La persona de contacto asumirá el rol de \"Administrador\" dentro del Telekom Data Intelligence Hub. Como administrador, tendrá autoridad para añadir o eliminar usuarios de su propia organización, supervisar roles y tomar decisiones comerciales sobre los servicios que ofrecemos. Transmitiremos los siguientes pasos para la incorporación de la organización a la persona de contacto por correo electrónico, y podrá monitorear el progreso en la página \"Resumen de invitaciones de socios\"."
    },
    "invite": {
      "additionalText": "Por favor, considere si desea invitar a organizaciones una por una, o en bloque, y haga su selección a continuación.",
      "bulkInvite": "Invitaciones en bloque",
      "bulkInviteHint": "Si desea realizar una invitación en bloque (>5 invitaciones), por favor selecciona esta opción.",
      "limitationHint": "Límite: Máximo 5 organizaciones. Para agregar más, selecciona \"Invitaciones en bloque\".",
      "singleInvite": "Invitación individual",
      "singleInviteHint": "Para invitar a 5 organizaciones o menos, por favor selecciona esta opción.",
      "orgNameLabel": "Ingrese nombre de la organización asociada",
      "emailLabel": "Ingrese correo del contacto",
      "groupInvite": "Invitación de grupo",
      "groupInviteHint": "Si desea invitar a varios grupos, seleccione esta opción.",
      "groupInviteInfo": "Puede agregar varios grupos. Límite: máximo 5 invitaciones de grupo.",
      "groupDetails": "Detalles del grupo:",
      "groupSelect": "Seleccione un grupo y para agregar",
      "groupRequired": "El campo Nombre del grupo es obligatorio",
      "groupUnique": "Este grupo ya ha sido agregado",
      "groupCreate": "+ Crear un nuevo grupo"
    },
    "inviteStatus": {
      "INVITED": "Invitado",
      "COMPLETED": "Aceptado",
      "FAILED": "Rechazado"
    },
    "upload": {
      "hint": "Para invitar a múltiples organizaciones, siga los siguientes pasos:",
      "step1": "Descargue el archivo de plantilla desde el enlace de abajo",
      "step2": "Rellene el archivo con los datos del invitado(s).",
      "step3": "Suba el archivo en el área proporcionada",
      "downloadTemplate": "Descargar plantilla",
      "templateHeader": {
        "organizationName": "nombre_de_la_organizacion",
        "email": "correo_electronico"
      },
      "templateFileName": "plantilla_de_invitaciones_masivas.csv",
      "learnMore": "Si desea más información sobre la invitación en bloque, por favor haz {clickHere}.",
      "clickHere": "clic aquí"
    },
    "report": {
      "invitationsInProgress": "Invitación(es) de {type} en curso",
      "invitationsSent": "Invitacion(es) enviadas",
      "error": {
        "errorsInInvitations": "Errores en {result} invitaciones enviadas",
        "single": {
          "invalidEmail": "La dirección de correo electrónico no es válida",
          "pleaseEnterValidEmail": "Por favor, introduzca una dirección de correo electrónico válida",
          "pleaseEnterValidOrganization": "El campo Nombre de la organización solo puede contener letras, números, espacios y los siguientes caracteres: & _ . - ' , ( ) +",
          "emailUnique": "El correo electrónico debe ser único",
          "pleaseEnterValidName": "Por favor, ingrese un nombre válido"
        },
        "bulk": {
          "allowedFileExtension": "Solo se permiten archivos con la extensión csv",
          "fileIsTooBig": "El archivo es demasiado grande. Puede subir archivos de hasta 1 MB",
          "formatMismatch": "El archivo no coincide con el formato esperado. Utilice la plantilla proporcionada e inténtelo de nuevo",
          "duplicateEmail": "El archivo tiene {number} {duplicate}",
          "duplicate": "duplicado | duplicados",
          "fileHasNoEntries": "El archivo no tiene entradas",
          "invalidEmailAddresses": "{number} direcciones de correo electrónico no son válidas.",
          "invalidOrganizationNames": "{number} organizaciones tienen nombres inválidos.",
          "organizationAlreadyInvited": "{number} organizaciones ya han sido invitadas por su organización.",
          "kindlyDownloadReport": "Por favor, descargue el informe para ver más detalles",
          "limitExceededError": "Ha superado la cuota máxima de conectores según el acuerdo de contrato. Solo puedes invitar a {limit} de participantes más. Póngase en contacto con {email} para modificar el contrato y aumentar la cuota. Además, puedes retirar las invitaciones pendientes para liberar el cupo.",
          "noQuotaLeftError": "Ha agotado la cuota máxima de conectores según el acuerdo del contrato. No puede invitar a más participantes. Póngase en contacto con {email} para modificar el contrato y aumentar la cuota. Además, puedes retirar las invitaciones pendientes para liberar la cuota."
        },
        "processing": {
          "DUPLICATE_EMAILS": "Correos electrónicos duplicados detectados.",
          "EMAIL_ALREADY_EXIST": "El correo electrónico ya existe.",
          "SOMETHING_WENT_WRONG": "Algo salió mal.",
          "INVALID_EMAIL_FORMAT": "Formato de correo electrónico inválido.",
          "ALREADY_REGISTERED_DATASPACE_USER": "El usuario ya forma parte de {dataspaceName}."
        }
      },
      "template": {
        "fileName": "informe_de_invitaciones_masivas.csv"
      }
    },
    "abort": {
      "title": "Cancelar invitación",
      "confirmText": "¿Está seguro de que desea cerrar este proceso?",
      "informationText": "Sus invitaciones no serán enviadas."
    },
    "switchForm": {
      "title": "Descartar cambios",
      "confirmText": "¿Está seguro de que desea cambiar de formulario?",
      "informationText": "Sus cambios no se conservarán."
    }
  },
  "discover": {
    "welcome": {
      "title": "Descubra las ofertas de datos de nuestros socios y proveedores de confianza",
      "description1": "Toma decisiones basadas en datos.",
      "description2": "Los datos desempeñan un papel fundamental en las operaciones comerciales, ya que cumplen varias funciones esenciales, como la columna vertebral para la toma de decisiones, la segmentación del mercado y la generación de clientes potenciales. Los datos pueden hacer o deshacer el desarrollo de sus productos, optimizar la logística de su cadena de suministro o alimentar a su IA con la información que necesita para sacar las conclusiones que necesita para avanzar en sus objetivos.",
      "description3": "En el Data Intelligence Hub de Telekom ofrecemos una plataforma unificada para los proveedores de datos de toda Alemania. Explora tus opciones y sumérgete en ellas: es posible que encuentres una excelente opción para tus necesidades de datos. Ampliamos constantemente nuestra red de proveedores de datos, por lo que incluso si sus necesidades exactas no están cubiertas por nuestra oferta de datos actual, no sea un extraño: su ajuste perfecto de datos puede estar a días de distancia.",
      "buttonLabel": "Explorar productos de datos"
    },
    "dataOffers": {
      "title": "Ofertas de Datos",
      "filter": {
        "subjectAreas": "Áreas temáticas",
        "dataOfferingType": "Tipo de oferta de datos",
        "dataProvider": "Proveedor de datos"
      },
      "tiles": {
        "productType": "Producto de datos configurable",
        "dataspaceName": "Espacio de Datos del Data Intelligence Hub",
        "subjectArea": "Área temática",
        "massmovementAnalytics": "Análisis de movimiento masivo",
        "termsOfUse": "Términos de uso",
        "licensedRestricted": "Licenciado, restringido",
        "viewOffer": "Ver oferta",
        "product1": {
          "name": "Traffic Analytics por Motion Data",
          "summary": "Estadísticas detalladas del comportamiento de movimiento en Alemania, incluyendo dirección del movimiento, origen, destino, permitiendo análisis en diferentes niveles espaciales en cualquier región."
        },
        "product2": {
          "name": "Traffic Analytics PRO por Motion Data",
          "summary": "Mediciones detalladas del movimiento en Alemania, incluyendo dirección del movimiento, origen, destino, permitiendo análisis y comparaciones en y entre diferentes niveles espaciales en cualquier momento y en cualquier región."
        },
        "product3": {
          "name": "Visitor Analytics PRO por Motion Data",
          "summary": "Analiza información sobre el comportamiento de las visitas debido a los patrones de movimiento público, incluyendo el conteo total de usuarios a diario y por horas, conocimientos sociodemográficos y detalles de origen de los visitantes en cualquier región de Alemania. Siguiente nivel de opciones de análisis para el comportamiento de visitas en el sitio, combinando las ventajas de uno de los tamaños de muestra más grandes y una precisión espacial sin precedentes."
        }
      },
      "offerDetails": {
        "title": "Detalles de la oferta",
        "requestADemo": "Solicitar una demostración",
        "orderNow": "Pedir ahora",
        "productOverview": {
          "title": "Descripción general del producto",
          "whatUseCasesAreAddressed": "Qué casos de uso se abordan?",
          "exampleCarousel1": {
            "title": "Evaluación de grandes eventos",
            "text": "Obtenga información más detallada sobre los asistentes a un evento para elaborar estrategias eficaces y hacer frente a los obstáculos logísticos, seleccionar a los proveedores y patrocinadores adecuados para el evento y priorizar las medidas de seguridad aprovechando los datos de densidad de multitudes con mayor resolución espacial."
          },
          "exampleCarousel2": {
            "title": "Información para la planificación turística",
            "text": "Las autoridades turísticas pueden aprovechar los datos de visitas para mejorar la planificación y asignación de recursos, facilitando el desarrollo de mejores infraestructuras en las zonas turísticas más importantes. Esto incluye la implementación de una red de transporte sin fisuras según el análisis del tráfico peatonal en horas punta, la realización de un marketing específico eficiente y la planificación de servicios de emergencia y seguridad."
          },
          "exampleCarousel3": {
            "title": "Centros comerciales e información sobre el negocio minorista",
            "text": "La información sobre el comercio minorista puede revelar el número de clientes potenciales que atrae un centro comercial, un outlet o una calle comercial y su procedencia. Proporcionan datos sobre el tiempo que permanecen los visitantes, su mezcla sociodemográfica y su poder adquisitivo. El análisis de estos patrones a lo largo del tiempo permite identificar tendencias en el comportamiento de los visitantes. La información también ayuda a determinar si hay mejores ubicaciones alternativas y a evaluar la situación de los lugares competidores."
          },
          "exampleCarousel4": {
            "title": "Planificación urbana y evaluación",
            "text": "El análisis de los datos dinámicos de población permite planificar eficazmente las zonas residenciales y las infraestructuras para satisfacer las necesidades de los residentes. El uso eficiente de los recursos es otro ámbito importante de aplicación; así, las ciudades pueden reducir su consumo de energía y contribuir a la sostenibilidad."
          },
          "fromDataIntelligenceHub": {
            "title": "¿Qué le ofrece Telekom Data Intelligence Hub?",
            "ol": {
              "1": "Puede solicitar una demostración del proveedor de datos (Motion Data de T-Systems International GmbH) y obtener de nuestros expertos de confianza información detallada sobre este producto de datos.",
              "2": "Para productos comprables del proveedor de datos (Motion Data de T-Systems International GmbH):"
            },
            "ul": {
              "1": "Recibirá los informes de los productos de datos adquiridos en forma de archivos CSV para el intervalo de tiempo seleccionado, las ubicaciones y las métricas solicitadas.",
              "2": "Se le ofrecerá la aplicación «Connect & Integrate» para conectarse al proveedor de datos y acceder a los informes adquiridos.",
              "3": "Los informes pueden descargarse desde la vista «Consumir» de la aplicación «»Connect & Integrate«».",
              "4": "Además, se pueden solicitar a MotionData soluciones de cuadros de mando para los productos de datos adquiridos.",
              "5": "Disponibilidad de soporte y servicio técnico por correo electrónico y línea directa durante el horario laboral en alemán e inglés."
            }
          }
        },
        "generalInformation": {
          "availability": "Disponibilidad horaria",
          "contactProvider": "Contactar con el proveedor",
          "coverage": "Cobertura geográfica",
          "documentation": "Documentación",
          "guide": "Guía de introducción",
          "help": "Ayuda",
          "message": {
            "coverage": "¿Desea comprar información turística para otro país? {link}",
            "coverageLinkText": "Contacte con nosotros",
            "segmentation": "Para más información, consulte {link}.",
            "segmentationLinkText": "nuestra base de conocimientos"
          },
          "missing": {
            "availability": "N/A",
            "coverage": "No se especifica la cobertura geográfica.",
            "description": "No hay descripción disponible.",
            "provider": "Proveedor desconocido.",
            "segmentation": "No hay segmentación espacial disponible.",
            "source": "No hay fuente de datos disponible.",
            "visualization": "No hay visualización de datos disponible."
          },
          "mockData": {
            "dataSpace": "Espacio de datos Data Intelligence Hub",
            "dataProvider": "MotionData de T-Systems International GmbH",
            "dataSource": "Datos de señalización anonimizados y agregados (activos y pasivos) de abonados de telefonía móvil en la red de Deutsche Telekom (incluidos los itinerantes) en Alemania.",
            "dataVisualization": "A petición del proveedor de datos, se pueden obtener cuadros de mando detallados y fáciles de usar.",
            "description": "El análisis de visitantes proporciona opciones de análisis de siguiente nivel para el comportamiento de las visitas in situ desde cualquier lugar de Alemania. Aprovechando los datos históricos derivados de los datos de señalización móvil anonimizados proporcionados por la red celular de Deutsche Telekom, y combinando las ventajas de una de las muestras de mayor tamaño y una precisión espacial sin precedentes, el análisis de visitantes permite a empresas e institutos desarrollar estrategias óptimas para acelerar su crecimiento con decisiones inteligentes basadas en datos. Este producto de datos está disponible en forma de informes en formato de archivos CSV y se entregan a través de nuestras soluciones de conectores de confianza mediante el espacio de datos Data Intelligence Hub.",
            "from": "01/07/2024",
            "geographicalCoverage": "Alemania",
            "geoLocationData": "Datos de geolocalización",
            "location": "Frankfurt am Main, Alemania",
            "locationType": "Sede central",
            "logo": "testLogoString",
            "massMovementAnalytics": "Análisis de movimientos de masas",
            "spatialSegmentation": "Cualquier ubicación (definida por un polígono o una coordenada x/y) con una zona de influencia determinada de 150 m/300 m.",
            "to": "Presente",
            "verificationLabel": "Entidad legal verificada por el nodo Gaia-X Digital Clearing House de T-Systems"
          },
          "provider": "Proveedor de datos",
          "segmentation": "Segmentación espacial",
          "source": "Fuente de datos",
          "title": "Información general",
          "visualization": "Visualización de datos"
        },
        "sampleData": {
          "title": "Muestra de datos",
          "dataPackage": "Paquete de datos",
          "description": "Descripción",
          "descriptionText": "Recuentos únicos de visitantes en el tiempo (por día o por hora de la hora de inicio) más recuentos diarios de visitantes desglosados por edad, sexo, zona de origen (código postal / condado) e información de roaming.",
          "sampleDataFile": "Archivo de datos de muestra",
          "sampleDataFileDescription": "Recuento de visitantes únicos diarios en los PDI (Puntos de Interés) proporcionados",
          "schemaInformation": "Información del esquema",
          "referenceDocumentation": "Documentación de referencia",
          "totalFiles": "Total de archivos de datos",
          "fileName": {
            "pointsOfInterest": "Puntos de Interés",
            "productDescription": "Descripción del producto",
            "referenceShape": "Archivos de formas de referencia",
            "reports": "Informes",
            "roamerReference": "Descripción de referencia de Roamer"
          }
        },
        "termsOfUse": {
          "allowed": "Puede:",
          "mandatory": "Debe:",
          "mockData": {
            "mock1": "Utilizar los datos con fines comerciales",
            "mock2": "Procesar los datos en la infraestructura fuera de la Unión Europea",
            "mock3": "Revender los datos",
            "mock4": "Respetar el contenido del Acuerdo de Licencia",
            "mock5": "Términos y Condiciones Generales_Inglés",
            "mock6": "Términos y Condiciones Generales_Alemán"
          },
          "notAllowed": "No puedes:",
          "title": "Condiciones de uso"
        },
        "additionalInformation": {
          "label": "Etiqueta del campo:",
          "mockData": {
            "description": "Description of a metadata block. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
          },
          "title": "Información adicional"
        }
      },
      "orderVAPro": {
        "title": "¡Tome decisiones basadas en datos!",
        "step1SubTitle": "Configure su oferta de datos según los campos solicitados por el proveedor",
        "step2SubTitle": "Proporcionar información sobre las especificaciones del área",
        "step1of4": "Paso 1 de 4",
        "step2of4": "Paso 2 de 4",
        "step3of4": "Paso 3 de 4",
        "step4of4": "Paso 4 de 4",
        "features": {
          "title": "Visitor Analytics Pro",
          "feature1": "Alta resolución admite polígonos predefinidos de hasta 150 m de radio",
          "feature2": "Selección para varios días y polígonos posibles por pedido",
          "feature3": "El producto incluye datos por hora y por día de recuentos de visitantes únicos y otras métricas clave",
          "feature4": "Los paneles y la consulta están disponibles a pedido",
          "feature5": "Modo de entrega de archivos de datos sin problemas y de forma segura a través de soluciones confiables de Connect & Integre"
        },
        "dateTitle": "Intervalo de tiempo",
        "dateTooltip": "Especifique un período de tiempo que va desde un mínimo de 1 día en el que desea analizar los informes de Visitor Analytics Pro. El rango de tiempo se refiere al período durante el cual los datos se recopilan, miden y procesan, y se preparan para el análisis",
        "areaSelectionTitle": "Selección de área",
        "areaSelectionTooltip": "La selección de área en una distribución de datos implica reducir el conjunto de datos para incluir solo aquellas observaciones o mediciones que pertenecen a un área geográfica de interés particular.",
        "validDays": "Número total de días(s) válidos:",
        "segmentTypeLabel": "Seleccionar tipo de segmentación espacial",
        "informationTypeLabel": "¿Cómo le gustaría proporcionar esta información?",
        "totolPOICount": "Recuento(s) total(es) de puntos de interés:",
        "confirmSelection": "Confirmar selección",
        "totalPOICounts": "Recuento(s) total de puntos de interés:",
        "priceFetchingProgressMsg": "Estamos obteniendo sus precios...",
        "priceFetchingError": "No se pueden obtener sus precios",
        "totalPriceText": "Precio total:",
        "vatText": "(sin IVA)",
        "premiumCustomerHighlight": "Con un pedido superior a 10.000 €, usted es nuestro Cliente Premium. Nos comunicaremos en un correo electrónico separado para discutir más opciones de colaboración",
        "reviewPageHeading": "Resumen de su pedido",
        "name": "Nombre",
        "monthlyCharges": "Cargos mensuales",
        "oneTimeCharges": "Cargos únicos",
        "yourSelectedProduct": "Su producto seleccionado",
        "product": "Producto",
        "timeSelection": "Selección de tiempo",
        "type": "Tipo:",
        "areaSelection": "Selección de área",
        "spatialInput": "Entrada espacial: Puntos de interés (POI)",
        "inputType": "Tipo de entrada: Seleccionar puntos de interés predefinidos",
        "viewMap": "Ver mapa",
        "additionalServices": "Servicios adicionales",
        "supportServices": "Servicios de soporte",
        "essentialSupport": "Soporte esencial 5/8",
        "totalAmount": "Importe total (euros)",
        "resultSuccessHeading": "Gracias por realizar el pedido",
        "resultParaText1": "Sus archivos estarán disponibles en breve, gracias por su paciencia.",
        "resultParaText2": "Si tiene alguna pregunta o consulta, no dude en ponerse en contacto con nosotros.",
        "membershipBtn": "Ir a mi membresía",
        "mapPoi": "POI:",
        "mapCity": "Ciudad:",
        "mapCoordinates": "Coordenadas:",
        "pickDate": "Elige una fecha",
        "from": "De",
        "to": "Para",
        "selectDate": "Selecciona una fecha",
        "poiDropdown": "Puntos de interés (POI)",
        "mapSelection": "Seleccionar puntos de interés (POI) en un mapa",
        "fileUpload": "Cargar shapefiles de puntos de interés preferidos",
        "predefinedSelection": "Seleccionar puntos de interés predefinidos"
      }
    }
  },
  "ospOnboarding": {
    "help": "Ayuda",
    "welcome": {
      "title": "Bienvenido a Catena-X - La red de automoción",
      "card": {
        "note": "Por favor, rellene el siguiente formulario para completar el registro de su empresa en Catena-X.",
        "point-1": "El formulario de registro consta de 3 pasos y le llevará aproximadamente 5-10 minutos de su tiempo",
        "point-2": "Dado que su organización ya está registrada en Telekom Data Intelligence Hub, rellenaremos previamente el formulario con sus datos disponibles para que el proceso de cumplimentación sea lo más fácil y fluido posible.",
        "point-3": "Puede consultar nuestra guía de ayuda en nuestra base de conocimientos en cualquier momento para comprender mejor este proceso de registro. Haga clic en {hereLink} para obtener más información",
        "here": "aquí",
        "letStarted": "Comencemos"
      }
    },
    "title": "Registro en el ecosistema Catena-X",
    "description": "Regístrese en Catena-X introduciendo toda la información solicitada en los siguientes 3 pasos",
    "description2": "Por favor, finalice el registro de la empresa completando las siguientes tareas para participar activamente y utilizar todas las funciones del Portal de la Red de Automoción de Catena-X.",
    "note": "Por favor, introduzca toda la información requerida antes de continuar. Más información en nuestra sección de {help}.",
    "companyDataStepTitle": "Datos de la empresa",
    "companyRoleStepTitle": "Rol de la empresa",
    "verifyAndSubmitStepTitle": "Verificar y enviar",
    "companyData": {
      "title": "Añada los datos de su empresa",
      "description": "Por favor, añada a continuación los datos de su empresa. Los campos obligatorios están resaltados con (*) y el formulario está pre-rellenado con la información que ya nos ha proporcionado durante la incorporación.",
      "organizationName": "Nombre de la organización",
      "organizationNameTooltip": "Nombre de la organización registrada",
      "enterYourData": "Introduzca sus datos",
      "bpn": "Número de socio comercial",
      "bpnTooltip": "El número de socio comercial (BPN) es un identificador único que se asigna a cada socio comercial en el ecosistema Catena-X.",
      "legalEntityName": "Nombre de la entidad jurídica",
      "transliteratedName": "Nombre transliterado (Caracteres latinos)",
      "registeredName": "Nombre registrado",
      "orgAddress": "Dirección de la organización",
      "streetName": "Nombre de la calle",
      "houseNumber": "Número de la casa",
      "postCode": "Código postal",
      "city": "Ciudad",
      "countryCode": "Código del país",
      "region": "Región",
      "companyIdentifier": "Identificador de la empresa",
      "identifierType": "Tipo de identificador",
      "identifierNumber": "Número identificador",
      "contactInfo": "Información de contacto",
      "emailAddress": "Dirección de correo electrónico",
      "userRole": "Rol del usuario",
      "CRN": {
        "label": "Número de registro comercial",
        "helpText": "Ejemplo: HRB 55933",
        "tooltipText": "El número de registro comercial es un identificador único asignado a las empresas para su registro comercial legal. Se utiliza para validar y verificar la autenticidad de los identificadores de registro y transacciones financieras de una empresa con fuentes de datos de confianza."
      },
      "vatId": {
        "label": "Número de IVA",
        "helpText": "Ejemplo: DE 118 645 675",
        "tooltipText": "El número de IVA (Impuesto sobre el Valor Añadido) es un identificador único que se asigna a las empresas para fines fiscales."
      }
    },
    "companyRole": {
      "title": "Rol de su empresa",
      "description": "Seleccione uno o varios roles de empresa con los que desee actuar/participar en la red Catena-X. El rol de la empresa siempre puede actualizarse/modificarse posteriormente. Dependiendo del rol seleccionado, los servicios del portal ofrecidos pueden variar.",
      "activeParticipanyNote": "Adapte y optimice su participación en Catena-X con T-Systems Connect & Integrate para una conexión fácil y automatizada a Catena-X. Solicite Connect & Integrate en Cofinity App Marketplace para los principales casos de uso de Catena-X y comience a intercambiar datos inmediatamente. A partir de 49EUR/mes y disponible para todos los tamaños de industria.",
      "agreeTermsCheckbox": "Sí, acepto el {link} del rol seleccionado",
      "activeParticipantNote": {
        "para1": "Adapte y optimice su participación en Catena-X con {link} para una conexión fácil y automatizada a Catena-X.",
        "tSystemsConnectAndIntegrate": "T-Systems Connect & Integrate",
        "para2": "Solicite Connect & Integrate en Cofinity App Marketplace para los principales casos de uso de Catena-X y comience a intercambiar datos inmediatamente.",
        "para3": "A partir de {price}/mes y disponible para todos los tamaños de industria"
      },
      "appProviderNote": {
        "para1": "{link} le permite desarrollar, gestionar y certificar aplicaciones empresariales dentro de nuestro entorno oficial Catena-X Sandbox.",
        "para2": "¡Ordene Build & Operate hoy y permítanos manejar su infraestructura de espacio de datos mientras usted se enfoca en la innovación!",
        "para1PlaceholderLink": "Build & Operate de T-Systems",
        "optionalInformation": "Información opcional"
      }
    },
    "verifyAndSubmit": {
      "title": "Verifique sus datos de registro",
      "description": "Verifique los datos de registro de su empresa antes de enviar el registro. Asegúrese de que todos los datos están correctamente cumplimentados. Una vez finalizada la verificación, haga clic en el botón Enviar para someter el registro a aprobación.",
      "companyData": "Datos de la empresa",
      "activeRole": "Rol activo",
      "consentText": "Doy mi consentimiento para que T-Systems International GmbH envíe mi solicitud de registro a Cofinity-X GmbH y procese los datos personales pertinentes con el fin de completar el procedimiento de incorporación y otros fines relacionados. Reconozco que mis datos serán tratados de conformidad con las leyes y reglamentos aplicables en materia de protección de datos, incluido, entre otros, el Reglamento General de Protección de Datos (RGPD). Entiendo que mis datos personales solo se almacenarán durante el tiempo necesario para cumplir estos fines. Soy consciente de que este consentimiento es necesario para el registro y la incorporación a Cofinity-X GmbH, y que puedo retirar mi consentimiento en cualquier momento con efecto para el futuro."
    },
    "actions": {
      "back": "Volver atrás",
      "next": "Siguiente",
      "submit": "Enviar"
    },
    "validation": {
      "DE_COMMERCIAL_REG_NUMBER": "Por favor, introduzca un número válido. Sugerencia: Alfanumérico con guión y espacio con 9 dígitos exactos.",
      "DE_VAT_ID": "Por favor, introduzca un número válido. Sugerencia: Empezando por DE y seguido de números de 9 dígitos.",
      "Worldwide_COMMERCIAL_REG_NUMBER": "Por favor, introduzca un número válido. Sugerencia: Alfanumérico con guión de 6 a 21 dígitos.",
      "Worldwide_VAT_ID": "Por favor, introduzca un número válido. Sugerencia: Alfanumérico con guión y espacio de 8 a 15 dígitos.",
      "invalid_bpn": "Número BPN no válido. El número BPN debe empezar por BPNL seguido de 12 caracteres alfanuméricos."
    },
    "error": {
      "title": "Error de validación",
      "para": "O bien su organización ya existe en la red Cofinity-X, o bien existen problemas técnicos que se están resolviendo actualmente. Por favor, háganos saber más sobre su experiencia para que podamos ayudarle más.",
      "buttonText": "Contáctenos"
    },
    "success": {
      "title": "Gracias por enviar su solicitud",
      "para": "Sus datos han sido enviados a Cofinity-X, recibirá información sobre los próximos pasos por correo electrónico",
      "buttonText": "Aller à la page d’accueil"
    }
  },
  "demoOrg": {
    "title": "Organización de demostración",
    "tooltip": "Esta es una organización de Demostración/Evaluación.",
    "tooltip1": "Algunas funcionalidades pueden ser limitadas."
  }
}